'use strict';

var resourcebooking = angular.module('gymsystem.resourcebooking', []);

resourcebooking.controller('ResourceWorkScheduleCtrl', ['$scope', function($scope) {
    $scope.tabSettings = ['my'];
    $scope.scheduleTitle = 'Schedule';
}]);

resourcebooking.controller('ResourceBookingTabsetController', ['$scope', '$controller', function($scope, $controller) {
    $controller('BaseTabsetController', {$scope: $scope});

    var waitingWatch = $scope.$watch('category', function(newValue) {
        if (newValue) {
            $scope.init($scope.category.multiBooking ? 'freemulti' : 'freesingle');
            waitingWatch();
        }
    });
}]);

resourcebooking.controller('ResourceBookingCategoryListCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', function($rootScope, $scope, $controller, $filter, $modal, server) {
    $controller('ActiveTableCtrl', {$scope: $scope});
    $controller('InactiveTableCtrl', {$scope: $scope});
    $scope.title = 'Categories';
    $scope.itemTitle = 'Category';

    $scope.getItems = function() {
        return $rootScope.resourcebookingcategories;
    };

    var showDialog = function(t) {
        var options = {controller: 'RemoveResourceBookingServiceModalCtrl', item: t, itemTitle: t.name, getUsageUrl: '/api/resourcebooking/category/countUsage', content: 'REMOVE_RESOURCEBOOKINGCATEGORY_MESSAGE', postUrl: '/api/resourcebooking/category/remove', showInactivate: false};
        $scope.removeModal(options);
    };

    $scope.change = function(category) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ResourceBookingCategoryChangeModalCtrl',
            resolve: {
                category: function() {
                    return category;
                }
            }
        });
    };

    $scope.copyCategory = function(category) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ResourceBookingCategoryAddModalCtrl',
            resolve: {
                category: function() {
                    var copy = angular.copy(category);
                    delete copy.id;
                    return copy;
                }
            }
        });
    };

    $scope.getShow = function(category) {
        return $filter('translate')(category.show ? 'Yes' : 'No');
    };

    $scope.getMulti = function(category) {
        return $filter('translate')(category.multiBooking ? 'Yes' : 'No');
    };

    function getImage(category) {
        if (category.imagekey) {
            return $rootScope.image('resourcebookingcategory', category, 100);
        }
    }

    $scope.canMoveUp = function(category) {
        var items = $scope.resourcesCategoryConfig.tabs[0].config.control.getItems();
        var index = items.indexOf(category);
        return index > 0;
    };

    $scope.canMoveDown = function(category) {
        var items = $scope.resourcesCategoryConfig.tabs[0].config.control.getItems();
        var index = items.indexOf(category);
        return index < items.length - 1;
    };

    $scope.up = function(category) {
        if ($scope.canMoveUp(category)) {
            var items = $scope.resourcesCategoryConfig.tabs[0].config.control.getItems();
            var index = items.indexOf(category);
            var one = category.order;
            var two = items[index-1].order;
            server.post('/api/resourcebooking/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.down = function(category) {
        if ($scope.canMoveDown(category)) {
            var items = $scope.resourcesCategoryConfig.tabs[0].config.control.getItems();
            var index = items.indexOf(category);
            var one = category.order;
            var two = items[index+1].order;
            server.post('/api/resourcebooking/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.rowClick = $scope.change;

    $scope.giveFocus = false;
    $scope.columns = [
        {field: 'image', title: '', src: getImage},
        {field: 'name', title: 'Category', visible: function() {return true;} },
        {field: 'show', title: 'Show for customers', visible: function() {return true;}, getValue: $scope.getShow },
        {field: 'multiBooking', title: 'Allow multi bookings', visible: function() { return true; }, getValue: $scope.getMulti }
    ];

    $scope.buttons = [

        { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyCategory },
        { title: 'Change', buttonClass: 'btn-warning', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && resource.active; }, onClick: $scope.change, tooltip: 'Change details' },

        { title: 'Move up', buttonClass: 'btn-warning', onClick: $scope.up, visible: function(c) { return c.active && $scope.canMoveUp(c); } },
        { title: 'Move down', buttonClass: 'btn-warning', onClick: $scope.down, visible: function(c) { return c.active && $scope.canMoveDown(c); }},

        { title: 'Inactivate', buttonClass: 'btn-danger', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && resource.active; }, onClick: function(t) { $scope.inactivateModal(t, t.name, 'INACTIVATE_RESOURCEBOOKINGCATEGORY_MESSAGE', '/api/resourcebooking/category/change'); }, tooltip: 'Inactivate'},

        { title: 'Activate', buttonClass: 'btn-success', visible: function(resource) {return !resource.active; }, onClick: function(t) { $scope.activateModal(t, t.name, 'ACTIVATE_RESOURCEBOOKINGCATEGORY_MESSAGE', '/api/resourcebooking/category/change'); }, tooltip: 'Activate' },
        { title: 'Remove', buttonClass: 'btn-danger', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && !resource.active; }, onClick: function(t){showDialog(t);}, tooltip: 'Remove' }


    ];

    $scope.addCategory = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResourceBookingCategoryAddModalCtrl',
            resolve: {
                category: function(){
                    return {}
                }
            }
        });
    };

    var inActiveOnEmpty = {
        title: 'Disabled categories will be collected here. They are then saved and can be activated again at a later time.',
        text: 'To deactivate a category, go to the "Active" tab above and press "Disable" on the category.'
    };

    $scope.resourcesCategoryConfig = {
        buttonBelow: function() {
            return $scope.button1;
        },
        getItems: function() {
            return $rootScope.resourcebookingcategories;
        },
        triggers: ['resourcebookingcategory'],
        countSuffixList: ['Category', 'Categories'],
        empty: {
            title: 'Here you can offer services',
            text: 'RESOURCEBOOKING_EMPTY_STATE',
            button: { title: 'Create service', onClick: $scope.addService }
        },
        giveFocus: function() {
            return false;
        },
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(staff) { return staff.active; } },
            { name: 'Inactive', itemFilter: function(resources) { return !resources.active; }, empty: inActiveOnEmpty }
        ],
        rowClick: $scope.change,
        columns: $scope.columns,
        buttons: $scope.buttons,
        searchButtons: [
            { title: 'Add category', buttonClass: 'btn-success', onClick: $scope.addCategory },
        ]
    };


}]);

resourcebooking.controller('ResourceBookingCategoryAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'category', function($rootScope, $scope, $controller, $filter, category) {
    $controller('ResourceBookingCategoryChangeModalCtrl', {$scope: $scope, category: category});

    $scope.title = "Add category";
    $scope.submitTitle = 'Add category2';
    $scope.postUrl = '/api/resourcebooking/category/add';
    $scope.successTitle = 'Category added';
    $scope.failedTitle = 'Failed to add category';
    $scope.callCloseOnSuccess = true;

    function nameAlreadyInUse() {
        var items = $rootScope.resourcebookingcategories.filter(c => c.name == _.findWhere($scope.fields, {name: 'name'}).value && _.findWhere($scope.fields, {name: 'name'}).value);
        if (items && $scope.item.id && items.some(i => i.id == $scope.item.id) && items.length == 1) {
            return false;
        } else if (items.length > 0){
            return true;
        } else {
            return false;
        }
    }

    if(!category.name){
        $scope.setInitialValues = function() {
            var color = "#"+((1<<24)*Math.random()|0).toString(16);
            _.findWhere($scope.fields, {name: 'sites'}).value = [$rootScope.selectedSite];
            _.findWhere($scope.fields, {name: 'color'}).value = color;
            _.findWhere($scope.fields, {name: 'confirmTemplate'}).value = $filter('translate')('BOOKING_CONFIRM_MAIL');
            _.findWhere($scope.fields, {name: 'confirmTemplateRebooking'}).value = $filter('translate')('REBOOKING_CONFIRM_MAIL');
            _.findWhere($scope.fields, {name: 'show'}).value = true;
        };

        $scope.fields = [
            {value: 'The categories are displayed to the customer and will help them find the right service on your website.', type: 'alert', class: 'alert-info' },
            {name: 'name', title: 'Category name', required: true, type: 'text'},
            {name: 'nameHint', hintClass: 'alert-warning', hint: 'The name is already used for another category', visible: nameAlreadyInUse},
            {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
            {name: 'description', title: 'Description', required: false, type: 'htmleditor', helpText: 'Shown to customers on the category page' },
            {name: 'show', title: 'Show category for customers', required: false, type: 'checkbox'},
            {name: 'color', title: 'Schedule color', required: false, type: 'color'},
            {name: 'multiBooking', title: 'Allow multi bookings', required: false, type: 'checkbox', helpText: 'If checked, the customer can choose several booking times, otherwise only one time can be booked at a time.' },
            {name: 'confirmTemplate', title: 'Confirmation text', required: false, type: 'htmleditor', helpText: 'Sent to the customer when the booking is made' },
            {name: 'confirmTemplateRebooking', title: 'Confirmation text for rebooking', required: false, type: 'htmleditor', helpText: 'Sent to the customer when the booking is made' },
            {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'resourcebookingcategory', imageOnly: true, squareThumbnail: false} },
        ];

        $scope.setInitialValues();
    }
}]);

resourcebooking.controller('ResourceBookingCategoryChangeModalCtrl', ['$rootScope', '$scope', 'category', '$modal', '$controller', function($rootScope, $scope, category, $modal, $controller) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.category = category;
    $scope.item = category;
    $scope.postUrl = '/api/resourcebooking/category/change';

    $scope.titleSuffix = function() {
        return $scope.category.name;
    };

    function nameAlreadyInUse() {
        var items = $rootScope.resourcebookingcategories.filter(c => c.name == _.findWhere($scope.fields, {name: 'name'}).value && _.findWhere($scope.fields, {name: 'name'}).value);
        if (items && $scope.item.id && items.some(i => i.id == $scope.item.id) && items.length == 1) {
            return false;
        } else if (items.length > 0){
            return true;
        } else {
            return false;
        }
    }

    $scope.fields = [
        {value: 'The categories are displayed to the customer and will help them find the right course on your website.', type: 'alert', class: 'alert-info' },
        {name: 'name', title: 'Category name', required: true, type: 'text' },
        {name: 'nameHint', hintClass: 'alert-warning', hint: 'The name is already used for another category', visible: nameAlreadyInUse},
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
        {name: 'description', title: 'Description', required: false, type: 'htmleditor', helpText: 'Shown to customers on the category page' },
        {name: 'show', title: 'Show category for customers', required: false, type: 'checkbox'},
        {name: 'color', title: 'Schedule color', required: false, type: 'color'},
        {name: 'multiBooking', title: 'Allow multi bookings', required: false, type: 'checkbox', helpText: 'If checked, the customer can choose several booking times, otherwise only one time can be booked at a time.' },
        {name: 'confirmTemplate', title: 'Confirmation text', required: false, type: 'htmleditor', helpText: 'Sent to the customer when the booking is made' },
        {name: 'confirmTemplateRebooking', title: 'Confirmation text for rebooking', required: false, type: 'htmleditor', helpText: 'Sent to the customer when the booking is made'},
        {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'resourcebookingcategory', imageOnly: true, squareThumbnail: false} },
    ];

    $scope.setValues($scope.category);
}]);

// ResourceBookingService

resourcebooking.controller('ResourceBookingServiceListCtrl', ['$rootScope', '$scope', '$controller', '$filter','util', function($rootScope, $scope, $controller, $filter, util) {
    $controller('ActiveTableCtrl', {$scope: $scope});
    $controller('InactiveTableCtrl', {$scope: $scope});
    $scope.title = 'Services';
    $scope.itemTitle = 'Service';
    $scope.showEmpty = true;

    $scope.getItems = function() {
        return $rootScope.resourcebookingservices;
    };

    $scope.itemFilter = function(item) {
        return item.active && item.category.active;
    };

    $scope.change = function(service) {
        util.showDataDialog({controller: 'ServiceDataCtrl', item: service, windowClass: 'large-modal-window'})
    };

    $scope.getShow = function(service) {
        return $filter('translate')(service.show ? 'Yes' : 'No');
    };

    $scope.getCategoryName = function(service) {
        return _.findWhere($rootScope.resourcebookingcategories, {id: service.category_id}).name;
    };

    $scope.getResources = function(service) {
        return Array.mergeSort(_.pluck(service.staffs, 'name')).join(', ');
    };
    var showDialog = function(t) {
        var options = {controller: 'RemoveResourceBookingServiceModalCtrl', getUsageUrl: '/api/resourcebooking/service/countUsage', item: t, itemTitle: t.name, content: 'REMOVE_RESOURCEBOOKINGSERVICE_MESSAGE', postUrl: '/api/resourcebooking/service/remove', showInactivate: false };
        $scope.removeModal(options);
    };

    var getProduct = function(service) {
        var product = $rootScope.getTrainingCards().filter(function(c) { return c.active && c.resourcebookingservice_id == service.id && c.service_base_product; });
        if (!product.length) {
            return;
        }

        return product[0];
    };

    var getPrice = function(service) {
        var product = getProduct(service)
        return product ? product.price : null;
    }

    var getAccount = function(service) {
        var service = $rootScope.getTrainingCards().filter(function(c) { return c.active && c.resourcebookingservice_id == service.id });
        if (!service.length) {
            return;
        }

        return service[0].account;
    }

    $scope.rowClick = $scope.change;

    function getImage(service) {
        if (service.imagekey) {
            return $rootScope.image('resourcebookingservice', service, 100);
        }

        if (service.category.imagekey) {
            return $rootScope.image('resourcebookingcategory', service.category, 100);
        }
    }

    $scope.copyService = function(s) {
        var copy = angular.copy(s);
        delete copy.id;

        var p = getProduct(s);
        if(p){
            copy.price = p.price;
            copy.methods = p.methods;
            copy.customerCanBuy = p.customerCanBuy;
            copy.vat = p.vat;
        }
        copy.account = getAccount(s);
        util.showDataDialog({controller: 'ServiceDataCtrl', item: copy, windowClass: 'large-modal-window',});
    }

    $scope.columns = [
        {field: 'image', title: '', src: getImage},
        {field: 'name', title: 'Service', visible: function() {return true;} },
        {field: 'category_id', title: 'Category', visible: function() {return true;}, getValue: $scope.getCategoryName },
        {field: 'duration', title: 'Duration', visible: function() {return true;} },
        {field: 'breakafter', title: 'Break after', visible: function() {return true;} },
        {field: 'price', title: 'Price', visible: function() {return true;}, getValue: getPrice, format: 'price' },
        {field: 'show', title: 'Show for customers', visible: function() {return true;}, getValue: $scope.getShow },
        {field: 'staffs', title: 'Resources', visible: function() {return true;}, getValue: $scope.getResources }
    ];

    $scope.buttons = [
        { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyService},
        { title: 'Change', buttonClass: 'btn-warning', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && resource.active; }, onClick: $scope.change, tooltip: 'Change details' },
        { title: 'Inactivate', buttonClass: 'btn-danger', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && resource.active; }, onClick: function(t) { $scope.inactivateModal(t, t.name, 'INACTIVATE_RESOURCEBOOKINGSERVICE_MESSAGE', '/api/resourcebooking/service/change'); }, tooltip: 'Inactivate'},

        { title: 'Activate', buttonClass: 'btn-success', visible: function(resource) {return !resource.active && resource.category.active; }, onClick: function(t) { $scope.activateModal(t, t.name, 'ACTIVATE_RESOURCEBOOKINGSERVICE_MESSAGE', '/api/resourcebooking/service/change'); }, tooltip: 'Activate' },
        { title: 'Remove', buttonClass: 'btn-danger', visible: function(resource) {return $rootScope.hasPermission('Resource booking') && !resource.active; }, onClick: function(t){showDialog(t);}, tooltip: 'Remove' }
    ];

    $scope.addService = function () {
        util.showDataDialog({controller: 'ServiceDataCtrl', windowClass: 'large-modal-window',});
    };

    var inActiveOnEmpty = {
        title: 'Disabled services will be collected here. They are then saved and can be activated again at a later time.',
        text: 'To deactivate a service, go to the "Active" tab above and press "Disable" on the service.'
    };

    $rootScope.waitFor(['resourcebookingservices', 'resourcebookingcategories', 'trainingcardtypes', 'sites']).then(function() {
        $scope.resourcesConfig = {
            buttonBelow: function() {
                return $scope.button1;
            },
            getItems: function() {
                return $rootScope.resourcebookingservices;
            },
            triggers: ['resourcebookingservice', 'trainingcardtype'],
            countSuffixList: ['Service', 'Services'],
            empty: {
                title: 'Here you can offer services',
                text: 'RESOURCEBOOKING_EMPTY_STATE',
                button: { title: 'Create service', onClick: $scope.addService }
            },
            orderColumn: 'name',
            tabs: [
                { name: 'Active', badgeClass: 'badge-success', itemFilter: function(staff) { return staff.active && staff.category.active; } },
                { name: 'Inactive', itemFilter: function(resources) { return !resources.active; }, empty: inActiveOnEmpty }
            ],
            rowClick: $scope.change,
            columns: $scope.columns,
            buttons: $scope.buttons,
            searchButtons: [
                { title: 'Add service', buttonClass: 'btn-success', onClick: $scope.addService }
            ],
            showSum: false
        };
    });
}]);

resourcebooking.controller('ServiceDataCtrl', ['$rootScope', '$scope', '$modal', 'util', 'server', 'accounts', 'productCategoryService', 'paymentMethods', 'options', '$filter', function($rootScope, $scope, $modal, util, server, accounts, productCategoryService, paymentMethods, options, $filter) {

    $scope.service = options.item || {};

    if ($rootScope.speedy && $rootScope.hasModule('RBDoorAccess')) {
        $rootScope.loadActiveResourcesForSite();
    }

    function getProduct() {
        var product = $rootScope.getTrainingCards().filter(function(c) { return c.active && c.resourcebookingservice_id == $scope.service.id && c.service_base_product; });
        if (!product.length) {
            return;
        }
        return product[0];
    }

    var changePrice = function() {
        var product = getProduct();
        if (!product) {
            return;
        }

        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: $rootScope.isProduct(product) ? 'ProductChangeModalCtrl': 'TrainingCardTypeChangeModalCtrl',
            resolve: {
                product: function() {
                    return product;
                },
                trainingCardType: function() {
                    return product;
                }
            }
        });
    };

    var doorAccessActivated = function () {
        return $scope.config.control.getField('doorAccess').value;
    };

    var continuousBookingActive = function() {
        return $scope.config.control.getField('continuousBooking').value;
    };

    var continuousBookingChange = function() {
        var durationField = $scope.config.control.getField('duration');
        durationField.min = continuousBookingActive() ? 1 : 10;
    };

    var initialFreeOptions = [
        {id: 'day', name: 'days'},
        {id: 'hour', name: 'hours'},
        {id: 'minute', name: 'minutes'}
    ];

    var maxDurationUnits = {
        required: false,
        name: 'maxDurationUnits',
        change: () => {
            var maxDurationField = $scope.config.control.getField('maxDuration');
            if (maxDurationField.unit.value?.id == 'none') {
                maxDurationField.readonly = true;
                maxDurationField.value = null;
            }
            else {
                maxDurationField.readonly = false;
            }
        },
        options: [
            {id: 'none', name: 'None', multiplier: 0},
            {id: 'day', name: 'Days', multiplier: 1440},
            {id: 'hour', name: 'Hours', multiplier: 60},
            {id: 'minute', name: 'Minutes', multiplier: 1},
        ],
        value: {id: 'none', name: 'None'}
    };

    var initialFreeOptionVisible = function(type) {
        var initialFreeTypeField = $scope.config.control.getField('initialFreeType');
        if (!initialFreeTypeField || !initialFreeTypeField.visible()) { return false; }
        return initialFreeTypeField.value && initialFreeTypeField.value.id === type;
    };

    function getActiveProductsExceptVariants() {
        return $rootScope.getActiveProducts().filter(function(product) { return !product.needs_to_choose_variant() && !$rootScope.isPackageProduct(product); });
    }

    function includedProductAmountTooHigh() {
        const amounts = $scope.config.control.getField('included_products_amount').value;
        if(amounts == null) {return false;}
        var total = 0;
        Object.values(amounts).forEach(function(value) {
            total += Number(value);
        });
        const fieldPrice = Number($scope.config.control.getField('price').value);
        const product = getProduct();
        const price = options.config.mode != 'change' || !product ? fieldPrice : product.price;
        return total > price;
    }

    var showMethods = function() {
        return $rootScope.hasModule('WebShop') && options.config.mode != 'change';
    };

    function showEmptyStaffCapacity() {
        var enableCapacity = $scope.config.control.getField('enable_capacity');
        var staffCapacity = $scope.config.control.getField('staff_capacity');
        return enableCapacity.value && (!staffCapacity.value || Object.keys(staffCapacity.value).length === 0);
    }

    $scope.addCategory = function() {
        var modalInstance = $modal.open({ templateUrl: 'views/addmodal.html', controller: 'ResourceBookingCategoryAddModalCtrl', resolve: { category: function() {return {}}} });
        modalInstance.result.then(function(addedCategory) {
            var c = $scope.config.control.getField('category_id');
            util.waitForNewObject(addedCategory.id, function(id) { return _.findWhere(c.options(), {id: id}); }, 'resourcebookingcategory').then(function(category) {
                c.value = category;
            });
        });
    };

    function getWebShopMethodName(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    }

    function serviceNameAlreadyInUse(){
        var services = $rootScope.resourcebookingservices.filter(s => s.name == $scope.config.control.getField('name').value);

        if(services && options.config.mode == 'change' && services.some(s => s.name == $scope.service.name) && services.length == 1){
            return false;
        }else if(services.length > 0){
            return true;
        }else{
            return false;
        }
    }

    function setAccountValue(value) {
        $scope.config.control.getField('account').value = value;
    }

    var accountField = accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && options.config.mode != 'change' }, null, null, null, null, null, null, null, null, setAccountValue);

    $scope.config = _.deep_extend(options.config, {
        datatype: 'service',
        url: {
            add: '/api/resourcebooking/service/add',
            change: '/api/resourcebooking/service/change',
            copy: '/api/resourcebooking/service/add'
        },
        data: {
            accounts: $rootScope.hasPermission('Accounting') && accountField.promise
        },
        initCallChange: true,
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Service name', required: true, type: 'text'},
                    {name: 'name_hint', hint: 'The name is already used for another service', hintClass: 'alert-warning', visible: function(){return serviceNameAlreadyInUse()}},
                    {name: 'category_id', title: 'Service category', useId: true, required: true, type: 'select', options: function() {return $rootScope.resourcebookingcategories; }, optionsFilter: {active: true}, addButtonClicked: $scope.addCategory, addButtonTitle: 'New category', helpText: 'HELPTEXT_SERVICE_CATEGORY', noResultsText: 'Start by creating a category', skipTranslation: true },
                    {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
                    {name: 'description', title: 'Short description', required: false, type: 'htmleditor', helpText: 'HELPTEXT_SHORT_DESCRIPTION'},
                    {name: 'longdescription', title: 'Long description', required: false, type: 'htmleditor', helpText: 'HELPTEXT_LONG_DESCRIPTION'},
                    {name: 'show', title: 'Show for customers', required: false, type: 'checkbox'},
                    {name: 'extendedInfo', title: 'Questions when booking', required: false, type: 'multifields',  options: { itemTitle: 'question' }, visible: function() { return !continuousBookingActive(); } },
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'resourcebookingservice', imageOnly: true, squareThumbnail: false}, visible: function() { return $rootScope.zoeziMyBusiness } },
                    {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
                ]
            },
            {
                name: 'Booking',
                fields: [
                    {name: 'manualConfirm', title: 'Confirm bookings manually', required: false, type: 'checkbox', visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_MANUAL_CONFIRM' },
                    {name: 'continuousBooking', title: 'Continuous booking', required: false, type: 'checkbox', hint: 'CONTINUOUS_BOOKING_INFO', change: continuousBookingChange },
                    {name: 'minimum_booking_time', title: 'Minimum booking time', required: false, type: 'infoNumber', info: 'minutes', getValue: function(field) { return field.value?Number(field.value):null;}, visible: function() { return !continuousBookingActive();}},
                    {name: 'initialFreeType', title: 'Free first period', required: false, type: 'select', placeholder: 'No free period', visible: function() { return $scope.config.control.getField('continuousBooking').value; }, options: function() { return initialFreeOptions; }, useId: true },
                    {name: 'initialFree', title: 'Free first period - duration', required: true, type: 'infoNumber', info: 'days', min: 1, visible: function() { return initialFreeOptionVisible('day'); }},
                    {name: 'initialFree', title: 'Free first period - duration', required: true, type: 'infoNumber', info: 'hours', min: 1, visible: function() { return initialFreeOptionVisible('hour'); }},
                    {name: 'initialFree', title: 'Free first period - duration', required: true, type: 'infoNumber', info: 'minutes', min: 1, visible: function() { return initialFreeOptionVisible('minute'); }},
                    {name: 'maxDuration', helpText: 'HELPTEXT_MAXDURATION',title: 'Max duration', readonly: maxDurationUnits.value?.id == 'none', required: false, type: 'unitNumber', unit: maxDurationUnits, min: 1, visible: function() { return $scope.config.control.getField('continuousBooking').value; }},
                    {name: 'duration', title: 'Duration', required: true, type: 'infoNumber', info: 'minutes', min: $scope.service.continuousBooking ? 1 : 10},
                    {name: 'breakafter', title: 'Break between bookable events', required: true, type: 'infoNumber', info: 'minutes',  visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_BREAK_AFTER' },
                ]
            },
            {
                name: 'Resources',
                fields: [
                    {name: 'staffs', title: 'Resources', required: true, type: 'customers', itemTypes: ['staff', 'resource'], helpText: 'If several are selected, the customer can choose between them when booking' },
                    {name: 'enable_capacity',helpText: 'HELPTEXT_CAPACITY_ADAPTED' },
                    {name: 'staff_capacity', hint: "HELPTEXT_CAPACITY_ADAPTED"},
                    {name: 'staff_capacity_empty', title: 'Maximum number of bookings per occasion and resource', type: 'label', setValue: function() { return $filter('translate')('Add resource above') }, visible: showEmptyStaffCapacity},
                    {name: 'xstaffs', title: 'Additional resource', required: false, type: 'customers', itemTypes: ['staff', 'resource'], visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_XSTAFFS' },
                    {name: 'resources', title: 'Optional resource', required: false, type: 'customers', itemTypes: ['staff', 'resource'], visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_OPTIONAL_RESOURCES'  },
                    {name: 'customer_selectable_resources', title: 'CUSTOMER_SELECTABLE_RESOURCES', type: 'checkbox', visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_CUSTOMER_SELECTABLE_RESOURCES' },
                    {name: 'allowFreeTime', title: 'Allow staff to select any time', required: false, type: 'checkbox', visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_ALLOW_FREETIME' },
                    {name: 'schedule_id', title: 'Available at certain times?', required: false, useId: true, type: 'customer', itemTypes: ['schedule'], helpText: 'HELPTEXT_SCHEDULE' },
                    {name: 'doorAccess', title: 'Access to doors', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('RBDoorAccess'); }, helpText: 'HELPTEXT_DOOR_ACCESS' },
                    {name: 'doorAccessBefore', title: 'Time before booking start', required: true, type: 'infoNumber', info: 'minutes', visible: function() { return $rootScope.hasModule('RBDoorAccess') && doorAccessActivated(); } },
                    {name: 'doorAccessAfter', title: 'Time after booking end', required: true, type: 'infoNumber', info: 'minutes', visible: function() { return $rootScope.hasModule('RBDoorAccess') && doorAccessActivated(); } },
                    {name: 'doorAccessResources', title: 'Doors', required: false, type: 'multiselect', options: $rootScope.getActiveDoors, placeholder: 'All', useId: true, visible: function() { return $rootScope.hasModule('RBDoorAccess') && doorAccessActivated(); } },
                ]
            },
            {
                name:'Price',
                fields: [
                    { name: 'price', title: 'Price for an occasion', type: 'button', buttonClass: 'btn-warning', buttonTitle: 'Change', click: changePrice, visible: function() { return options.config.mode == 'change' } },
                    { name: 'price', title: 'Price for an occasion', required: true, type: 'price', visible: function() { return options.config.mode == 'add' || options.config.mode == 'copy' }, value: $scope.service.price, helpText: 'Price incl. VAT' },
                    { name: 'vat', title: 'VAT', type: 'select', required: true, options: () => $rootScope.valueAddedTax, visible: function() { return options.config.mode == 'add' || options.config.mode == 'copy' },  useId: true, value: $scope.service.vat || ''},
                    {name: 'customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('WebShop') && !continuousBookingActive() && options.config.mode != 'change'; } },
                    {name: 'methods', title: 'Payment methods', type: 'multiselect', visible: showMethods, options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', getName: getWebShopMethodName, useId: true, helpText: 'HELPTEXT_PAYMENT_METHOD' },
                    accountField,
                    {name: 'additional_products', visible: function() { return !continuousBookingActive(); }, helpText: 'HELPTEXT_ADDITIONAL_PRODUCTS' },
                    {name: 'included_products', title: 'Included products', type: 'multiselect', options: getActiveProductsExceptVariants, useId: true},
                    {name: 'included_products_amount'},
                    {hint: 'Sum cannot be higher than the service price', hintClass: 'alert-danger', visible: includedProductAmountTooHigh },
                ]
            }
        ],
        getSubmitItem: function() {
            var item = $scope.config.control.getSubmitItem();
            if (item.continuousBooking) {
                var maxDurationField = $scope.config.control.getField('maxDuration');
                item.maxDuration = (maxDurationField.value * (maxDurationField.unit.value?.multiplier ?? 0)) || null;
            }
            return item;
        },
        canSubmit: () => {
            return !includedProductAmountTooHigh();
        },
        init: function() {

            // Included products
            (function() {
                var fieldIncludedProducts = $scope.config.control.getField('included_products');
                var fieldProductMap = $scope.config.control.getField('included_products_amount');

                util.setupCustomMapField($scope, fieldIncludedProducts, fieldProductMap, {
                    title: 'Price for product',
                    visible: function() {
                        return fieldIncludedProducts.value && fieldIncludedProducts.value.length;
                    },
                    getNameByKey: function(key) {
                        var product = _.findWhere($rootScope.getActiveProducts(), {id: Number(key)});
                        return product ? product.name : key;
                    }
                });
            })();

            function getAdditionalProducts() {
                var additionalProducts = $rootScope.getActiveProducts();
                additionalProducts.push.apply(additionalProducts, $rootScope.getActiveTrainingCards());
                return additionalProducts;
            }

            // additional products
            (function() {
                var field = $scope.config.control.getField('additional_products');
                _.extend(field, {
                    title: 'Additional products',
                    required: false,
                    type: 'multiselect',
                    options: getAdditionalProducts,
                    optionsFilter: function(t) { return !t.resourcebookingservice_id && t.active && !t.valuecard && !$rootScope.isPackageProduct(t); },
                    placeholder: 'Choose products',
                    group: function() {return 'Product';},
                    orderPredicate: function() {return 0;},
                    value: [],
                    setValue: function(field, value) {
                        if(!value || !value.length) {return [];}
                        var result = [];
                        value.forEach(function(id) {
                            result.push(_.findWhere($rootScope.trainingcardtypes, {id: id}));
                        });
                        return result;
                    },
                    getValue: function(field) {
                        return _.pluck(field.value, 'id');
                    }
                });

            })();

            // max duration
            (function() {
                if ($scope.service.maxDuration > 0) {
                    var maxDurationField = $scope.config.control.getField('maxDuration');
                    if ($scope.service.maxDuration % 1440 == 0) {
                        $scope.service.maxDuration /= 1440;
                        maxDurationField.unit.value = _.findWhere(maxDurationField.unit.options, { multiplier: 1440 });
                    }
                    else if ($scope.service.maxDuration % 60 == 0) {
                        $scope.service.maxDuration /= 60;
                        maxDurationField.unit.value = _.findWhere(maxDurationField.unit.options, { multiplier: 60 });
                    }
                    else{
                        maxDurationField.unit.value = _.findWhere(maxDurationField.unit.options, { multiplier: 1 });
                    }
                    maxDurationField.readonly = false;
                }
                else{
                    $scope.service.maxDuration = null;
                }
            })();

            // Capacity
            (function() {
                var fieldStaffs = $scope.config.control.getField('staffs');
                if(!fieldStaffs.value){fieldStaffs.value = []}
                var fieldCapacityEnable = $scope.config.control.getField('enable_capacity');
                var fieldCapacityMap = $scope.config.control.getField('staff_capacity');

                fieldCapacityEnable.title = 'Capacity';
                fieldCapacityEnable.type = 'checkbox';
                fieldCapacityEnable.visible = function() {
                    return $rootScope.hasModule('ResourceBooking');
                };

                util.setupCustomMapField($scope, fieldStaffs, fieldCapacityMap, {
                    title: 'Custom capacity',
                    visible: function() {
                        return !!fieldCapacityEnable.value;
                    },
                    getNameByKey: function(key) {
                        var staff = $scope.getStaff(key);
                        return staff ? staff.name : key;
                    },
                    watchExpr: function() {
                        return fieldCapacityEnable.value + ',' + _.pluck(fieldStaffs.value, 'id').join(',');
                    },
                    enabled: function() {
                        return !!fieldCapacityEnable.value;
                    }
                });
            })();

            if(!options.item) {
                return {
                    breakafter: 0,
                    sites: [$rootScope.selectedSite],
                    show: true,
                    allowFreeTime: true,
                };
            }
        },
    });
}]);

resourcebooking.controller('ResourceBookingCardDataCtrl', ['$rootScope', '$scope', '$modal', 'util', 'server', 'accounts', 'productCategoryService', 'paymentMethods', 'options', function($rootScope, $scope, $modal, util, server, accounts, productCategoryService, paymentMethods, options) {

    $scope.item = options.item || {};

    $scope.priceTypes = [ {name: 'OneTime'}, {name: 'Day'}, {name: 'Week'}, {name: 'Month'}, {name: 'Quarter'}, {name: 'HalfYear'}, {name: 'Year'} ];
    $scope.dateTypes = [ {name: 'Day'}, {name: 'Week'}, {name: 'Month'}, {name: 'Quarter'}, {name: 'HalfYear'}, {name: 'Year'} ];

    $scope.getDateTypes = function() {
        return $scope.dateTypes;
    };

    $scope.setDateType = function(field) {
        return _.findWhere($scope.dateTypes, {name: $scope.item[field.name]});
    };

    $scope.getType = function(field) {
        return field.value ? field.value.name : null;
    };

    var isAuto = function() {
        return $scope.config.control.getField('auto').value;
    };

    $scope.getPriceTypes = function() {
        var auto = isAuto();
        return $scope.priceTypes.filter(function(t) {
            return !(t.name === 'OneTime' && auto);
        });
    };

    $scope.setPriceType = function(field) {
        return _.findWhere($scope.priceTypes, {name: $scope.item[field.name]});
    };

    function showCostCenter() {
        return $rootScope.hasPermission('Accounting') && $scope.costcenters && $scope.costcenters.length;
    }

    var setStock = function() {
        return $scope.item.stock != null;
    };

    var isStock = function() {
        return $scope.config.control.getField('stockB').value;
    };

    var getStock = function() {
        if (isStock()) {
            return $scope.config.control.getField('stock').value;
        } else {
            return null;
        }
    };

    var showBuyWithPoints = function() {
        var priceType = $scope.config.control.getField('priceType').value;
        var isAuto = $scope.config.control.getField('auto').value;
        return $rootScope.hasModule('LoyaltyPoints') && !isAuto && priceType.value && priceType.value.name == 'OneTime';
    };

    var pointsPriceVisible = function() {
        return showBuyWithPoints() && $scope.config.control.getField('buyWithPoints').value;
    };

    var bookingsLimitIntervalTypes = [ { name: 'Per day', id: 'day' }, { name: 'Per week', id: 'week' } ];
    var bookingsLimitIntervalVisible = function(type) {
        var field = $scope.config.control.getField('bookingsLimitIntervalType');
        return field && field.value && field.value.id == type;
    };

    var hasSessionsLimit = function() {
        return $scope.config.control.getField('trainingsessions').value;
    };

    var autoRenewSessionsOptions = [
        { id: 'reset', name: 'Reset number of training sessions' },
        { id: 'add', name: 'Add to existing training sessions' }
    ];
    var isRenewTypeAdd = function() {
        var value = $scope.config.control.getField('autoRenewSessions').value;
        return value && value.id === 'add';
    };

    function setAccountValue(value) {
        $scope.config.control.getField('account').value = value;
    }

    var accountField = accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, null, null, null, null, null, null, null, setAccountValue);

    function getWebShopMethodName(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'resourcebooking',
        url: {
            add: '/api/trainingcard/type/add',
            change: '/api/trainingcard/type/change',
            copy: '/api/trainingcard/type/add'
        },
        data: {
            costcenters: $rootScope.hasPermission('Accounting') && $rootScope.waitFor(['costcenters']),
            accounts: $rootScope.hasPermission('Accounting') && accountField.promise
        },
        initCallChange: true,
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'resourcebookingservice_id', title: 'Service', useId: true, required: true, type: 'select', options: $rootScope.getActiveResourceBookingServices},
                    {name: 'name', title: 'Name', required: true, type: 'text'},
                    {name: 'trainingsessions', title: 'Sessions', required: true, readonly: ($scope.item.service_base_product && options.config.mode == 'change'), type: 'number' },
                    {name: 'auto', title: 'Auto renewal', required: false, type: 'checkbox' },
                    {name: 'boundTime', title: 'Bound for', required: false, type: 'number', visible: function() { return isAuto(); }, min: 1, max: 1000 },
                    {name: 'boundType', title: '', useId: true, required: false, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: function() { return isAuto(); } },
                    {name: 'validTime', title: 'Valid for', required: true, type: 'number', visible: function() { return !isAuto(); } },
                    {name: 'validType', title: '', required: true, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: function() { return !isAuto(); } },
                    {name: 'autoRenewSessions', title: 'Renew training sessions automatically', required: false, helpText: 'AUTOMATICALLY_RENEW_SESSIONS_HELPTEXT', placement: 'right', placeholder: 'Do not renew', useId: true, type: 'select', options: function() { return autoRenewSessionsOptions; }, visible: function() { return isAuto() && hasSessionsLimit(); } },
                    {name: 'autoRenewSessionsMax', title: 'Maximum number of saved training sessions', required: false, placeholder: 'No limit', type: 'number', visible: function() { return isAuto() && hasSessionsLimit() && isRenewTypeAdd(); } },
                    {name: 'bookingsLimitIntervalType', title: 'Limit bookings by interval', type: 'select', required: false, placeholder: 'No limit', options: function() { return bookingsLimitIntervalTypes; }, useId: true },
                    {name: 'bookingsLimitInterval', title: 'Max number of bookings per day', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('day'); }, min: 1 },
                    {name: 'bookingsLimitInterval', title: 'Max number of bookings per week', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('week'); }, min: 1 },
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'product', imageOnly: true, squareThumbnail: true}},
                    {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
                ]
            },
            {
                name: 'Accounting',
                fields: [
                    {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true },
                    accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }),
                    {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.config.data.costcenters; }, visible: showCostCenter, useId: true},
                ]
            },
            {
                name: 'Checkout',
                fields: [
                    {name: 'price', title: 'Price', required: true, type: 'price' },
                    {name: 'priceType', title: '', useId: true, required: true, type: 'select', options: $scope.getPriceTypes, setValue: $scope.setPriceType, getValue: $scope.getType },
                    {name: 'customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox' },
                    productCategoryService.makeWebshopSelectField({ visible: function() {
                        if ($rootScope.hasFlag('flag-unified-sales-category')) {
                            return !$scope.item.service_base_product;
                        } else {
                            return $scope.config.control.getField('customerCanBuy').value;
                        }
                    } }),
                    {name: 'showSelfCheckout', title: 'Show in self checkout', required: false, type: 'checkbox' },
                    {name: 'buyWithPoints', title: 'Can be bought with points', type: 'checkbox', visible: showBuyWithPoints },
                    {name: 'pointsPrice', title: 'Points', required: true, type: 'number', visible: pointsPriceVisible, min: 1 },
                    {name: 'methods', title: 'Payment methods', type: 'multiselect', options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', hint: 'LIMITED_PAYMENTMETHODS', getName: getWebShopMethodName, useId: true },
                    {name: 'stockB', title: 'Limited amount', required: false, type: 'checkbox', setValue: setStock, skipChangedCheck: true},
                    {name: 'stock', title: 'Units in stock', required: false, type: 'number', getValue: getStock, visible: isStock, invisibleValue: null, nullIsValue: true },
                    {name: 'receiptComment', title: 'Comment on receipt', type: 'textarea' },
                    productCategoryService.makeSelectField()
                ]
            }
        ],
        getSubmitItem: function() {
            var item = $scope.config.control.getSubmitItem();
            if(!item.stockB) {item.stock = null;}
            delete item.stockB;
            return item;
        },
        init: function() {
            if (!options.item) {
                return {
                    vat: '25',
                };
            }
        },
    });
}]);

resourcebooking.controller('ResourceBookingBookCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$filter', '$modal', 'calendar', '$location', 'util', function($rootScope, $scope, $routeParams, $http, $filter, $modal, calendar, $location, util) {
    $scope.data = {};

    $scope.all = { all: true, name: 'All', active: true };

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'freesingle') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);

    $scope.serviceChanged = function() {
        $scope.data.selectedServiceStaffs = [];
        $scope.all.name = $filter('translate')('All');
        Array.prototype.push.apply($scope.data.selectedServiceStaffs, $scope.data.selectedService.staffs);
        $scope.data.selectedServiceStaffs.unshift($scope.all);
        $scope.data.selectedResource = $scope.all;
        $scope.getFreeSlots();
    };

    $scope.allFreeSlots = [];
    $scope.getFreeSlots = function() {
        var service = $scope.data.selectedService;
        var start = $scope.visStart;
        var end = $scope.visEnd;
        if (!service || !start || !end) {
            return;
        }

        $http.get('/api/resourcebooking/get/free?service=' + service.id + '&startTime=' + start.dateTime() + '&endTime=' + end.dateTime()).success(function(data) {
            var now = new Date();
            angular.forEach(data, function(slot) {
                slot.staffs = $rootScope.updatePointersById(slot.staffs, $rootScope.staffs);
                slot.service = service;
                slot.start = Date.newFull(slot.start);
                slot.end = Date.newFull(slot.end);
                slot.backgroundColor = service.category.color;
                slot.title = service.name;
                if (slot.start < now) {
                    slot.className = 'oldTime';
                }
            });

            if ($scope.appendExtraSlots) {
                $scope.appendExtraSlots(data);
            }

            calendar.adjustMinMax($scope.calendarConfig, data);

            $scope.allFreeSlots = data;
            $scope.updateStaffFilter();
        });
    };

    $scope.updateStaffFilter = function() {
        var filtered = $scope.allFreeSlots.filter($scope.isSelectedStaff);
        $scope.calendarSources[0] = filtered;
    };

    $scope.staffsChanged = function() {
        $scope.updateStaffFilter();
    };

    $scope.isSelectedStaff = function(slot) {
        return $scope.data.selectedResource === $scope.all || slot.staffs.some(staff => staff.id === $scope.data.selectedResource.id);
    };

    $scope.sampleStaff = function(slot) {
        var selectedStaffs = $scope.data.selectedResource == $scope.all ? $scope.data.selectedService.staffs : [$scope.data.selectedResource];

        const commonStaffs = slot.staffs.filter(slotStaff =>
            selectedStaffs.some(selectedStaff => selectedStaff.id === slotStaff.id));

        return _.sample(commonStaffs);
    };

    $scope.book = function(slot, readonlyService) {
        var staff = $scope.sampleStaff(slot);
        $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: [{slot: slot, staff: staff}], customer: null, readonlyService: readonlyService};
                }
            }
        });
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            $scope.getFreeSlots();
        }
    };
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation || calEvent.notClickable) {
            return;
        }

        $scope.book(calEvent);
    };

    $scope.calendarSources = [[]];

    calendar.updateTranslation([$scope.calendarConfig]);

    $scope.setCategory = function(category) {
        if ($rootScope.hasModule('MultiSite') && category.sites.indexOf($rootScope.selectedSite.id) == -1) {
            $location.path('/');
            return;
        }

        $scope.category = category;
        if(!$scope.rbooking) {  // can't change service if it's rebooking
            var services = $filter('filter')($rootScope.getActiveResourceBookingServices(), {category_id: category.id, active: true, continuousBooking: false}, true);
            if (services.length >= 1) {
                var ordered = $filter('orderBy')(services, 'name');
                $scope.data.selectedService = ordered[0];
                $scope.serviceChanged();
            }
        }
    };

    if ($routeParams.categoryId) {
        $rootScope.waitFor(['resourcebookingcategories', 'resourcebookingservices']).then(function() {
            $scope.setCategory($rootScope.getPointerById(Number($routeParams.categoryId), $rootScope.resourcebookingcategories));
        });
    }

    $scope.pubsub('selectedSite', function() {
        if ($scope.category) {
            $scope.setCategory($scope.category);
        }
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking') {
            $scope.getFreeSlots();
        }
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
        removeTranslateChangeSuccess();
    });
}]);

resourcebooking.controller('ResourceBookingMultiBookCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$filter', '$modal', 'calendar', 'server', 'util', function($rootScope, $scope, $routeParams, $http, $filter, $modal, calendar, server, util) {
    $scope.data = {};

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'freemulti') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);

    var invertColor = function(hexTripletColor) {
        var color = hexTripletColor;
        color = color.substring(1);           // remove #
        color = parseInt(color, 16);          // convert to integer
        color = 0xFFFFFF ^ color;             // invert three bytes
        color = color.toString(16);           // convert to hex
        color = ("000000" + color).slice(-6); // pad with leading zeros
        color = "#" + color;                  // prepend #
        return color;
    };

    $scope.setColor = function(slot) {
        slot.backgroundColor = slot.selected ? invertColor($scope.data.selectedService.category.color) : $scope.data.selectedService.category.color;
    };

    $scope.allFreeSlots = [];
    $scope.getFreeSlots = function() {
        var service = $scope.data.selectedService;
        var start = $scope.visStart;
        var end = $scope.visEnd;
        if (!service || !start || !end) {
            return;
        }

        var args = {service: service.id, startTime: start.dateTime(), endTime: end.dateTime()};
        if ($scope.getRbExcludeList) {
            args.rbExcludeList = $scope.getRbExcludeList().join(',');
        }

        server.get('/api/resourcebooking/get/free', args).then(function(data) {
            var now = new Date();
            var slots = [];
            angular.forEach(data, function(slot) {
                slot.staffs = $rootScope.updatePointersById(slot.staffs, $rootScope.staffs);
                slot.service = service;
                slot.start = Date.newFull(slot.start);
                slot.end = Date.newFull(slot.end);
                slot.backgroundColor = service.category.color;
                slot.className = ['calbigger'];
                if (slot.start < now) {
                    slot.className.push('oldTime');
                }

                // Split into new slots
                for (var i=0; i < slot.staffs.length; ++i) {
                    var split = angular.copy(slot);
                    split.staffs = [slot.staffs[i]];
                    split.allresources = split.staffs;

                    slots.push(split);
                }
            });

            if ($scope.appendExtraSlots) {
                $scope.appendExtraSlots(slots);
            }

            calendar.adjustMinMax($scope.calendarConfig, slots);

            $scope.allFreeSlots = slots;
            $scope.updateStaffFilter();
        });
    };

    $scope.serviceChanged = function() {
        var staffs = $scope.data.selectedService.staffs;
        staffs = $filter('orderBy')(staffs, 'name');
        $scope.selectedStaffs = staffs;
        $scope.calendarConfig.setResources($scope.selectedStaffs);
        if ($scope.calendarObject) {
            $scope.calendarObject.fullCalendar('render');
        }
        $scope.getFreeSlots();
    };

    $scope.updateStaffFilter = function() {
        var filtered = $scope.allFreeSlots.filter($scope.isSelectedStaff);
        $scope.calendarSources[0] = filtered;
    };

    $scope.staffsChanged = function() {
        $scope.updateStaffFilter();
    };

    $scope.isSelectedStaff = function(slot) {
        return $scope.selectedStaffs.some(selectedStaff =>
            slot.allresources.some(resource => resource.id === selectedStaff.id)
        );
    };

    $scope.getSelected = function() {
        return $scope.allFreeSlots.filter(function(slot) { return slot.selected; });
    };

    $scope.book = function() {
        var selected = $scope.getSelected();
        var bookingParts = [];
        for (var i=0; i < selected.length; ++i) {
            var slot = selected[i];
            var bp = {};
            bp.slot = slot;
            bp.staff = slot.staffs[0];
            bookingParts.push(bp);
        }

        var modalInstance = $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: bookingParts, customer: $scope.getCustomer && $scope.getCustomer() };
                }
            }
        });

        modalInstance.result.then(function () {
            for (var i=0; i < selected.length; ++i) {
                var slot = selected[i];
                slot.selected = false;
                $scope.setColor(slot);
                $scope.calendarObject.fullCalendar('renderEvent', slot);
            }

            if ($scope.callCloseOnSuccess) {
                $scope.$close();
            }
        });
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.header.right = null;
    $scope.calendarConfig.defaultView = 'agendaDay';
    $scope.calendarConfig.setResources($scope.selectedStaffs);
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            $scope.getFreeSlots();
        }
    };

    var changedSlot;
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            return;
        }

        if(calEvent === changedSlot) {  // clicked by mousedown
            changedSlot = null;
            return;
        }

        calEvent.selected = !calEvent.selected;
        $scope.setColor(calEvent);
        this.style.backgroundColor = calEvent.backgroundColor;
    };

    var mouseDown = 0;
    var selectionStatus;
    document.body.onmousedown = function() {
        ++mouseDown;
    };

    document.body.onmouseup = function() {
        --mouseDown;
    };

    $scope.calendarConfig.eventMouseover = function(calEvent, event) {
        if (mouseDown) {
            if (!selectionStatus) {
                selectionStatus = { selecting: !calEvent.selected };
            }

            if (selectionStatus.selecting != calEvent.selected) {
                if(event.type == 'mousedown') {changedSlot = calEvent;}
                calEvent.selected = selectionStatus.selecting;
                $scope.setColor(calEvent);
                this.style.backgroundColor = calEvent.backgroundColor;
            }
        } else {
            selectionStatus = null;
        }
    };

    $scope.calendarSources = [[]];

    calendar.updateTranslation([$scope.calendarConfig]);

    $scope.setCategory = function(category) {
        $scope.category = category;
        if(!$scope.rbooking) {  // can't change service if it's rebooking
            var services = $filter('filter')($rootScope.resourcebookingservices, {category_id: category.id, active: true}, true);
            if (services.length >= 1) {
                var ordered = $filter('orderBy')(services, 'name');
                $scope.data.selectedService = ordered[0];
                $scope.serviceChanged();
            }
        }
    };

    if ($routeParams.categoryId) {
        $rootScope.waitFor(['resourcebookingcategories', 'resourcebookingservices']).then(function() {
            $scope.setCategory($rootScope.getPointerById(Number($routeParams.categoryId), $rootScope.resourcebookingcategories));
        });
    }

    $scope.pubsub('selectedSite', function() {
        if ($scope.category) {
            $scope.setCategory($scope.category);
        }
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking' || message.type == 'workschedule' || message.type == 'resourcebookingservice') {
            $scope.getFreeSlots();
        } else if (message.type == 'user' && (message.action == 'add' || message.action == 'remove')) {
            $scope.serviceChanged();
        }
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
        removeTranslateChangeSuccess();
        document.body.onmousedown = undefined;
        document.body.onmouseup = undefined;
    });
}]);

resourcebooking.controller('ResourceBookingBookedCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$filter', '$modal', 'calendar', 'server', 'resourceBooking', '$location', 'util', function($rootScope, $scope, $routeParams, $http, $filter, $modal, calendar, server, $resourceBooking, $location, util) {
    $scope.data = {};
    $scope.stats = {};

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'booked') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);


    $scope.allBookedTimes = [];
    $scope.getBookedTimes = function() {
        var start = $scope.visStart;
        var end = $scope.visEnd;
        if (!start || !end) {
            return;
        }

        server.post2('/api/resourcebooking/resource/get_resource_allocation', {
            resource_ids: _.pluck($scope.calendarConfig.resources, 'id'),
            start: start,
            end: end,
            mode: 'slots',
            category_id: Number($routeParams.categoryId),
            site_id: $rootScope.selectedSite.id,
            service_id: $scope.data.selectedService ? $scope.data.selectedService.id : null,
            include_other_services: true
        }).then(function(response) {
            $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                var rbookings = [];
                var totalPersons = 0;
                var totalBookings = 0;
                var totalSlots = 0;
                var countedBookings = {};
                response.forEach(function(data) {
                    if(data.slot) {
                        rbookings.push($resourceBooking.slotForCalendar(data));

                        // Slots from other services are shown so the resource is not
                        // drawn as free, but they do not belong in this service's stats.
                        if(data.other_service) {return;}

                        var rbservice = $rootScope.getPointerById(data.rbservice_id, $rootScope.resourcebookingservices);
                        if(!rbservice) {return;}

                        data.resource_booking.forEach(function(rb) {
                            if(countedBookings[rb.id]) {return;}
                            countedBookings[rb.id] = true;
                            totalBookings++;
                            var countBookings = 1;
                            if(rb.extra_person && rb.extra_person.length) {
                                countBookings += rb.extra_person.length;
                            }
                            totalPersons += countBookings;
                            totalSlots += countBookings * (rb.duration / rbservice.duration);
                        });
                    }
                });

                $scope.stats.totalBookings = totalBookings;
                $scope.stats.totalPersons = totalPersons;
                $scope.stats.totalSlots = totalSlots;

                calendar.adjustMinMax($scope.calendarConfig, rbookings);

                $scope.allBookedTimes = rbookings;
                $scope.updateStaffFilter();

                $scope.stats.resources = [];
                server.post2('/api/resourcebooking/resource/get_resource_stats', {
                    start: start,
                    end: end,
                    rbooking: Object.keys(countedBookings).map(Number)
                }).then(function(response) {
                    $scope.stats.resources = response.map(function(d) {
                        d.resource = $rootScope.getStaff(d.resource_id);
                        return d;
                    });
                });

            });
        });

    };

    $scope.updateStaffFilter = function() {
        var filtered = $scope.allBookedTimes.filter($scope.isSelectedStaff);
        $scope.calendarSources[0] = filtered;
        // Trigger reload
        $scope.calendarConfig.triggerChange = Math.random();
    };

    $scope.staffsChanged = function() {
        $scope.updateStaffFilter();
        $scope.calendarConfig.setResources($scope.data.selectedResources);
        $scope.calendarObject.fullCalendar('render');
    };

    $scope.isSelectedStaff = function(slot) {
        return $scope.data.selectedResources.some(selectedResource =>
            slot.staffs.some(slotStaff => slotStaff.id === selectedResource.id)
        );
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.header.right = null;
    $scope.calendarConfig.defaultView = 'agendaDay';
    $scope.calendarConfig.setResources($scope.data.selectedResources);
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view)) {
            $scope.getBookedTimes();
        }
    };
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            return;
        }
        if(calEvent.enableCapacity || (calEvent.resource_booking && calEvent.resource_booking.length != 1)) {
            $resourceBooking.showBookingList(calEvent);
        } else {
            $resourceBooking.openById(calEvent.resource_booking_id[0]);
        }
    };

    $scope.calendarSources = [[]];

    calendar.updateTranslation([$scope.calendarConfig]);

    $scope.updateAllStaffs = function() {
        var staffs = [];
        var services = [];
        if ($scope.data.selectedService) {
            services.push($scope.data.selectedService);
        } else {
            services = $rootScope.getActiveResourceBookingServices().filter(function(x) { return x.category_id == $scope.category.id;});
        }
        for (let service of services) {
            for (let staff of service.staffs) {
                if (!staffs.some(s => s.id === staff.id)) {
                    staffs.push(staff);
                }
            }
        }

        staffs = $filter('orderBy')(staffs, 'name');

        $scope.allStaffs = staffs;

        $scope.data.selectedResources = $scope.allStaffs;
        $scope.calendarConfig.setResources($scope.data.selectedResources);
        $scope.calendarObject.fullCalendar('render');
        $scope.getBookedTimes();
    };

    $scope.serviceChanged = function() {
        $scope.updateAllStaffs();
    };

    $scope.setCategory = function(category) {
        if (category.sites.indexOf($rootScope.selectedSite.id) == -1) {
            $location.path('/');
            return;
        }
        $scope.category = category;
        $scope.serviceChanged();
    };

    $rootScope.waitFor(['resourcebookingcategories', 'resourcebookingservices']).then(function() {
        $scope.setCategory($rootScope.getPointerById(Number($routeParams.categoryId), $rootScope.resourcebookingcategories));
    });

    $scope.pubsub('selectedSite', function() {
        if ($scope.category) {
            $scope.setCategory($scope.category);
        }
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking') {
            $scope.getBookedTimes();
        } else if (message.type == 'resourcebookingservice') {
            // FIXME: ? $scope.updateAllStaffs();
        }
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });


    $scope.$on('$destroy', function () {
        removeServerChange();
        removeTranslateChangeSuccess();
    });
}]);

resourcebooking.controller('ResourceBookingAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'options', 'server', 'paymentMethods', '$injector', 'live', 'util', '$q', 'formatter', function($rootScope, $scope, $controller, $filter, $modal, options, server, paymentMethods, $injector, live, util, $q, formatter) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.options = options;
    $scope.rebook = options.rebook;
    var firstPart = options.bookingParts[0];
    var service = firstPart.slot.service;
    var staff = firstPart.staff;
    var readonlyService = !!options.readonlyService || !!service;
    var originalTime;
    var single = options.bookingParts.length == 1;
    var plain = true, plainDuration;  // plain == true if bookings conform one slot

    options.bookingParts = options.bookingParts.slice().sort(function(a, b) {
        if(a.slot.start < b.slot.start) {return -1;}
        if(a.slot.start > b.slot.start) {return 1;}
        return 0;
    }).map(function(s) {
        return {
            slot: _.clone(s.slot),
            staff: s.staff
        };
    });

    if(options.bookingParts.length > 1) {
        var prev = null;
        options.bookingParts.forEach(function(s) {
            if(prev) {
                if(prev.slot.end.getTime() != s.slot.start.getTime()) {plain = false;}
                if(prev.staff.id != s.staff.id) {plain = false;}
            }
            prev = s;
        });
    }
    if(plain) {
        plainDuration = (options.bookingParts[options.bookingParts.length - 1].slot.end.getTime() - firstPart.slot.start.getTime()) / 60000;
    }

    $scope.postUrl = options.rebook ? '/api/resourcebooking/rebook' : '/api/resourcebooking/add';
    $scope.loadingStatus = {};

    $scope.getTitleOfModal = function() {
        var title = $filter('translate')(options.rebook ? 'Rebook' : 'Book');
        if (plain) {
            return title + ' ' + $filter('translate')('with') + ' ' + firstPart.staff.name;
        }
        return service && service.name ? title + ' ' + service.name : title;
    };

    var getSlotStart = function(slot, clicked) {
        if(clicked && slot.clickedSlotTime && slot.isAnnotation) {return slot.clickedSlotTime;}
        return slot.start;
    };

    $scope.getTitle = function(name) {
        if(!name) {return '';}
        var field = _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)});
        return field && field.title || '';
    };

    var getService = function() {
        return firstPart.slot.service || service || {};
    };

    $scope.serviceSelected = function() {
        return service != undefined;
    };

    $scope.book = function(mode) {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();

        var data = {
            duedate: item.duedate,
            method: item.method,
            optional_resource: item.optional_resource,
            extra_person: item.extra_person,
            invoiceExtraInfo: item.invoiceExtraInfo,
            send_confirmation: item.sendConfirmation,
        };
        if (item.customizeMessage) {
            data.custom_message = item.customMessage;
        }
        if ($scope.rebook) {
            data.old_resource = options.rbooking.staff;
        }

        var bookings = [];
        for (var i=0; i < options.bookingParts.length; ++i) {
            var bp = options.bookingParts[i];

            var b = {};
            b.service = (bp.slot.service || getService()).id;
            if (single) {
                var date = _.findWhere($scope.fields, {name: 'date'}).value;
                var time = _.findWhere($scope.fields, {name: 'time'}).value;
                if (service.allowFreeTime) {
                    time = Date.newFull(date.yyyymmdd() + ' ' + time.hhmm());
                    if(time.hhmm() !== originalTime) {
                        data.original_time = originalTime;
                    }
                } else {
                    time = getSlotStart(bp.slot);
                }
                b.start = time.dateTime();
                b.end = time.clone().addMinutes((bp.slot.service || getService()).duration).dateTime();
            } else {
                b.start = getSlotStart(bp.slot).dateTime();
                b.end = bp.slot.end.dateTime();
            }
            b.staff = bp.staff.id;
            b.note = item.note;
            b.member = item.customer;
            b.extendedInfo = item.extendedInfo;
            b.method = $scope.usePunchCard() ? 'punchcard' : item.method;
            b.xstaff_id = (item.xstaffs || {}).id;
            bookings.push(b);
        }
        if ($scope.repetition.isActive()) {
            var repetitionEndDate = $scope.repetition.getEndDate();
            var interval = $scope.repetition.getInterval();
            var intervalName = $scope.repetition.getIntervalName();
            var daysToAdd = intervalName === 'Every day' ? 1 : 7 * interval;

            var isFree = function(start, end) {
                return !_.find($scope.repetitionCollisions, function(b) {
                    return (start <= b.start && b.start < end) || (start < b.end && b.end <= end);
                });
            };

            var repetitionBookings = [];
            bookings.forEach(function(b) {
                var nextStart = Date.newFull(b.start).addDays(daysToAdd);
                var nextEnd = Date.newFull(b.end).addDays(daysToAdd);
                var nextDate = nextStart.clone().clearTime();
                while (nextDate && repetitionEndDate && nextDate <= repetitionEndDate) {
                    var nextB = angular.copy(b);
                    nextB.start = nextStart.dateTime();
                    nextB.end = nextEnd.dateTime();
                    if (isFree(nextStart, nextEnd)) {
                        repetitionBookings.push(nextB);
                    }

                    nextStart = nextStart.clone().addDays(daysToAdd);
                    nextEnd = nextEnd.clone().addDays(daysToAdd);
                    nextDate = nextStart.clone().clearTime();
                }
            });
            repetitionBookings = repetitionBookings.filter(function(b) {
                var bStart = Date.newFull(b.start);
                var bEnd = Date.newFull(b.end);
                return !_.find($scope.repetition.getBreaks(), function(br) {
                    return br && Date.rangeInside(bStart, bEnd, br.from, br.to);
                });
            });

            bookings = bookings.concat(repetitionBookings);
        }

        var products = [];
        angular.forEach($scope.basket, function(item) {
            var p = {};
            p.id = item.id;
            p.prod_id = item.product.id;
            p.count = item.count;
            p.price = item.price;
            p.variant = item.variant;
            products.push(p);
        });

        data.bookings = bookings;
        data.products = products;

        if (options.rebook) {
            data.id = options.rbooking.id;
        }

        server.post($scope.postUrl, data, null, 'Booking was added', 'Failed to add booking').then(function(result) {
            if (result.success) {
                $scope.$close();

                if(mode == 'checkout') {
                    var rbooking_id = result.data[0].id;
                    server.post2('/api/payment/get_by_resource_booking', {rbooking_id: rbooking_id}).then(function(payments) {
                        payments.forEach($rootScope.transformPayment);
                        var cashiers = $injector.get('cashiers');
                        var $location = $injector.get('$location');
                        cashiers.transferPayments(payments);
                        var ids = payments.map(function(p) { return p.id; }).filter(Boolean);
                        var search = {};
                        if (ids.length) search.payment_ids = ids.join(',');
                        var firstPayer = payments[0] && (payments[0].payer_id || payments[0].user_id);
                        if (firstPayer) search.customer_id = firstPayer;
                        $location.path('/checkout').search(search);
                    });
                }
            }

            $scope.loadingStatus.loading = false;
        });
    };

    var getDate = function() {
        return getSlotStart(firstPart.slot).clone();
    };

    var getTime = function() {
        var starts = [];
        var ends = [];
        angular.forEach(options.bookingParts, function(bp) {
            starts.push(getSlotStart(bp.slot));
            ends.push(bp.slot.end);
        });

        var start = Array.mergeSort(starts)[0];
        var end = Array.mergeSort(ends)[ends.length-1];
        return start.hhmm() + ' - ' + end.hhmm();
    };

    var getMethod = function() {
        return _.findWhere($scope.fields, {name: 'method'}).value;
    };

    var getCustomer = function() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    };

    var getInvoiceDays = function(whenDone) {
        if (!$scope.invoicedays && $rootScope.hasModule('Invoice')) {
            server.get('/api/invoice/settings/get').then(function(result) {
                $scope.invoicedays = result.days;
                whenDone(result.days);
            });
        } else {
            whenDone($scope.invoicedays);
        }
    };

    var setDueDate = function() {
        getInvoiceDays(function(days) {
            var method = _.findWhere($scope.fields, {name: 'method'}).value;
            var newDate = getDate();
            if (method.id == 'directdebit') {
                newDate = util.getBillingDate();
            } else if (method.id == 'invoice') {
                newDate.addDays(days);
            }

            _.findWhere($scope.fields, {name: 'duedate'}).value = newDate;
        });
    };

    var getMethodForCustomer = function(customer) {
        var payer = $rootScope.getMember(customer && ((options.customer &&  options.customer.paidBy) || customer.id));
        return paymentMethods.getDefaultForCustomer(payer);
    };

    var hasPaymentAndAmount = function() {
        return $rootScope.hasModule('Payment') && $scope.payment.toPay() > 0;
    };

    var isInvoice = function() {
        var method = _.findWhere($scope.fields, {name: 'method'});
        return method && method.value && method.value.id == 'invoice';
    };

    var getInvoiceSendDate = function() {
        var duedate = _.findWhere($scope.fields, {name: 'duedate'});
        if (duedate.value) {
            var d = _.findWhere($scope.fields, {name: 'duedate'}).value.clone();
            d.addDays(-$scope.invoicedays);
            if (d < Date.today()) {
                d = Date.today();
            }
            return d.yyyymmdd();
        }
    };

    var hasMoney = function() {
        var customer = getCustomer();
        if (customer) {
            return +customer.getValueCardAmountForSelectedLegalEntity() >= $scope.payment.toPay();
        }
    };

    var hasSavedCard = function() {
        var customer = getCustomer();
        return customer && customer.hasSavedCardForSelectedLegalEntity();
    };

    var isCardValid = function(card, date, trainings, service) {
        var validToDate = !card.validToDate || date < card.validToDate.clone().addDays(1);
        var notvalidFromDate = card.validFromDate > date;
        var validFromDate = !notvalidFromDate;
        var trainingsLeft = card.trainingsLeft >= trainings || card.trainingsLeft === null;
        if (validToDate && validFromDate && trainingsLeft && card.cardtype.resourcebookingservice_id == service.id) {
            return true;
        }
        return false;
    };

    $scope.trainingcards = [];

    // When rebooking, the clip(s) the booking was paid with are returned server-side
    // before the new booking is made and then reused — so no payment is created. The
    // spent card may be a 1-session included resource clip card, which is filtered out
    // of /api/trainingcard/get/all once depleted, so we can't detect availability from
    // the card list. Instead rely on the rebooked booking(s) having been clip-paid.
    var rebookKeepsPunchCard = function() {
        if (!options.rebook || !options.rbooking || !Array.isArray(options.rbooking.siblings)) { return false; }
        var sibs = options.rbooking.siblings.filter(function(s) { return !s.cancelled; });
        if (!sibs.length || !_.every(sibs, function(s) { return s.punchcard; })) { return false; }
        // Compare in clips, not booking/slot counts: one booking can span several
        // service-duration units (count = ceil(duration / service.duration)), so the new
        // selection is covered iff it needs no more clips than the rebooked bookings return.
        var serviceDuration = getService().duration || 1;
        var clipsFor = function(minutes) { return Math.max(1, Math.ceil(minutes / serviceDuration)); };
        var returnedClips = sibs.reduce(function(sum, s) { return sum + clipsFor(s.duration); }, 0);
        var neededClips = options.bookingParts.reduce(function(sum, bp) {
            return sum + clipsFor((bp.slot.end.getTime() - bp.slot.start.getTime()) / 60000);
        }, 0);
        return neededClips <= returnedClips;
    };

    var showPunchCard = function() {
        var customer = getCustomer();
        if (customer) {
            for (var i=0; i < $scope.trainingcards.length; ++i) {
                var card = $scope.trainingcards[i];
                if (isCardValid(card, getDate(), options.bookingParts.length, getService())) {
                    return true;
                }
            }
        }
    };

    $scope.usePunchCard = function() {
        if (rebookKeepsPunchCard()) { return true; }
        return showPunchCard() && _.findWhere($scope.fields, {name: 'punchcard'}).value;
    };

    var getTrainingCards = function() {
        $scope.trainingcards = [];
        var customer = getCustomer();
        if (customer) {
            server.get('/api/trainingcard/get/all', {member_id: customer.id}).then(function(trainingcards) {
                angular.forEach(trainingcards, function(trainingcard) {
                    $rootScope.transformTrainingCard(trainingcard);
                });
                $scope.trainingcards = trainingcards;
                if (showPunchCard()) {
                    _.findWhere($scope.fields, {name: 'punchcard'}).value = true;
                }
            });
        }
    };

    var editableTime = $scope.serviceSelected() ? (plain && service.allowFreeTime) : true;

    $scope.availableXStaffs = null;
    var getXStaffsForService = function() {
        return $scope.availableXStaffs ? $scope.availableXStaffs : getService().xstaffs || [];
    };

    var reloadAvailableXStaffsForService = function() {
        var deffered = $q.defer();
        if (!editableTime) {
            deffered.resolve();
            return deffered.promise;
        }

        var service = getService();
        if (!service || !service.id) {
            deffered.reject();
            return deffered.promise;
        }
        var date = _.findWhere($scope.fields, { name: 'date' }).value;
        var time = _.findWhere($scope.fields, { name: 'time' }).value;

        var start = time.clone();
        start.setFullYear(date.getFullYear());
        start.setMonth(date.getMonth());
        start.setDate(date.getDate());

        var end = start.clone();
        end.addMinutes(plainDuration);

        var params = {
            id: service.id,
            startTime: start.dateTime(),
            endTime: end.dateTime(),
            staff_id: staff.id
        };
        if (options.rebook && options.rbooking) {
            // Leave out the booking being rebooked so its own extra resource is not counted as busy.
            params.exclude = options.rbooking.id;
        }

        server.post('/api/resourcebooking/service/get_free_xstaffs', null, params).then(function(response) {
            $scope.availableXStaffs = _.filter(response.data, function(xstaff) {
                return xstaff.id != staff.id;
            });
            deffered.resolve();
        });

        return deffered.promise;
    };

    var setRandomXstaff = function() {
        var xstaffs = getXStaffsForService();
        var item = xstaffs.length > 0 ? xstaffs[Math.floor(Math.random()*xstaffs.length)] : null;
        (_.findWhere($scope.fields, { name: 'xstaffs' }) || {}).value = item;
    };

    var setInitialXstaff = function() {
        // On rebooking, keep the booking's own extra resource if it's still available; otherwise pick one.
        if (options.rebook && options.rbooking) {
            var ownId = options.rbooking.xstaff_id || (options.rbooking.xstaff && options.rbooking.xstaff.id);
            var own = ownId && _.findWhere(getXStaffsForService(), { id: ownId });
            if (own) {
                (_.findWhere($scope.fields, { name: 'xstaffs' }) || {}).value = own;
                return;
            }
        }
        setRandomXstaff();
    };

    var availableServices = [];
    var getServicesForStaff = function() {
        return availableServices;
    };
    var updateServiceSelection = function() {
        service = (_.findWhere($scope.fields, { name: 'service' }) || {}).value;
        if(service && plain) {
            plainDuration = service.duration;
        }
        reloadAvailableXStaffsForService().then(function() {
            setRandomXstaff();
        });
        _.findWhere($scope.fields, {name: 'customMessage'}).value = service?.category?.confirmTemplate ?? $filter('translate')('BOOKING_CONFIRM_MAIL');
        $scope.fields = $scope.fields.filter(function(f) { return !f.name.indexOf('extendedInfo.') == 0; });
        if(service?.extendedInfo) {
            util.addQuestions($scope.fields, service.extendedInfo, 'extendedInfo');
        }
    };

    var reloadAvailableServices = function(time) {
        var activeServices = $rootScope.getActiveResourceBookingServices();
        var ids = _.pluck(activeServices.filter(function(s) {return _.findWhere(s.staffs, { id: staff.id });}), 'id').join(',');
        var startTime = time ? time.dateTime() : (firstPart.slot.clickedSlotTime || firstPart.slot.start).dateTime();
        var args = {
            staffs: staff.id,
            service: ids,
            startTime: startTime,
            endTime: startTime,
            exactTime: true
        };
        server.get('/api/resourcebooking/get/free', args).then(function(response) {
            var used = {};
            availableServices.length = 0;
            response.forEach(function(s) {
                if(used[s.service_id]) {return;}
                used[s.service_id] = true;
                var service = _.findWhere(activeServices, {id: s.service_id});
                if(service) {
                    availableServices.push(service);
                }
            });
            updateServiceSelection();
        });
    };

    if(single && !service) {
        reloadAvailableServices();
    } else {
        availableServices = $rootScope.getActiveResourceBookingServices().filter(function(s) {return _.findWhere(s.staffs, { id: staff.id });});
    }

    var onTimeChange = function() {
        if (!$scope.serviceSelected()) {
            // Reload available services for the new time if no service is selected yet
            if (single && !service) {
                var date = _.findWhere($scope.fields, {name: 'date'}).value;
                var time = _.findWhere($scope.fields, {name: 'time'}).value;
                var newTime = Date.newFull(date.yyyymmdd() + ' ' + time.hhmm());
                reloadAvailableServices(newTime);
            }
            return;
        }

        if(plain && service.allowFreeTime) {
            var date = _.findWhere($scope.fields, {name: 'date'}).value;
            var time = _.findWhere($scope.fields, {name: 'time'}).value;
            time = Date.newFull(date.yyyymmdd() + ' ' + time.hhmm());
            var shift = time.getTime() - firstPart.slot.start.getTime();
            options.bookingParts.forEach(function(s) {
                if(!s.slot.referenceStartTime){
                    s.slot.referenceStartTime = s.slot.start;
                    s.slot.referenceEndTime = s.slot.end;
                }
                s.slot.start = new Date(s.slot.referenceStartTime.getTime() + shift);
                s.slot.end = new Date(s.slot.referenceEndTime.getTime() + shift);
            });
        }

        reloadAvailableXStaffsForService().then(function() {
            var xstaffsField = (_.findWhere($scope.fields, { name: 'xstaffs' }) || {});
            var selectedXstaffId = xstaffsField.value && xstaffsField.value.id;
            var xstaffs = getXStaffsForService();
            if (!_.findWhere(xstaffs, { id: selectedXstaffId })) {
                setRandomXstaff();
            }
            else {
                (_.findWhere($scope.fields, { name: 'xstaffs' }) || {}).value = _.findWhere(xstaffs, { id: selectedXstaffId });
            }
        });

        $scope.updateRepetition();
    };

    // The service requires extra resources but none are free at the chosen time.
    var xstaffsUnavailable = function() {
        return (getService().xstaffs || []).length > 0 && getXStaffsForService().length === 0;
    };

    $scope.canSubmit = function() {
        if($scope.baseProductInactive()) {return false;}
        if($scope.usePunchCard() && !$scope.repetition.hasSufficientPunchCard()) {return false;}
        if (hasPaymentAndAmount()) {
            var method = _.findWhere($scope.fields, {name: 'method'}).value.id;
            if ((method == 'valuecard' && !hasMoney()) || (method == 'stripe' && !hasSavedCard())) {
                return false;
            }
        }
        return !xstaffsUnavailable();
    };

    var xstaffsChanged = function() {
        if ($scope.repetition.isActive()) {
            $scope.updateRepetition();
        }
    };

    function showInvoiceFreeText() {
        var payMethod = _.findWhere($scope.fields, {name: 'method'}).value;
        return payMethod && payMethod.id === 'invoice';
    }

    function getServiceTitle() {
        return readonlyService ? 'Selected service' : 'Select service';
    }

    function showCustomConfirmation() {
        return  _.findWhere($scope.fields, {name: 'sendConfirmation'}).value;
    }

    function showCustomMessageField() {
        return showCustomConfirmation() && _.findWhere($scope.fields, {name: 'customizeMailing'}).value;
    }

    function getTemplate() {
        if ($scope.rebook) {
            return service?.category?.confirmTemplateRebooking ?? $filter('translate')('REBOOKING_CONFIRM_MAIL');
        } else {
            return service?.category?.confirmTemplate ?? $filter('translate')('BOOKING_CONFIRM_MAIL');
        }
    }

    $scope.fields = [
        {name: 'service', title: getServiceTitle(), type: 'select', options: getServicesForStaff, required: true, change: updateServiceSelection, value: service, readonly: readonlyService },
        {name: 'date', title: 'Date', type: 'date', readonly: true, value: getDate() },
        {name: 'time', title: 'Time', type: editableTime ? 'time' : 'label', value: getSlotStart(firstPart.slot, true).clone(), required: editableTime, change: onTimeChange, getValue: editableTime?null:getTime },
        {name: 'customer', title: 'Customer', type: 'customer', required: true, value: options.customer },
        {name: 'xstaffsHint', hint: 'XSTAFFS_NOT_AVAILABLE', visible: xstaffsUnavailable },
        {name: 'xstaffs', title: 'Additional resource', type: 'select', options: getXStaffsForService, required: true, visible: function() { return $scope.serviceSelected() && (getService().xstaffs || []).length > 0; }, change: xstaffsChanged },
        {name: 'note', title: 'Note', type: 'textarea', required: false, value: options.rebook && options.rbooking.note },
        {name: 'punchcard', title: 'Punch card', type: 'checkbox', required: true, visible: function() { return showPunchCard() && !rebookKeepsPunchCard(); }  },
        {name: 'method', title: 'Payment method', type: 'paymentmethod', required: true, value: getMethodForCustomer(options.customer), visible: hasPaymentAndAmount, options: {create: true}, hasMoney: hasMoney, hasSavedCard: hasSavedCard },
        {name: 'invoiceExtraInfo', title: 'Invoice comment (max 150 characters)', required: false, visible: showInvoiceFreeText, type: 'textarea', maxlength: 150 },
        {name: 'sendDate', title: 'Invoice date', required: false, type: 'label', visible: function() { return hasPaymentAndAmount() && isInvoice();}, getValue: getInvoiceSendDate },
        {name: 'duedate', title: 'Due date', type: 'date', required: true, visible: hasPaymentAndAmount },
        {name: 'sendConfirmation', title: 'Send confirmation mail to customer', type: 'checkbox', value: true },
        {name: 'customizeMailing', title: 'Customize mailing', type: 'checkbox', value: false, visible: showCustomConfirmation },
        {name: 'customMessage', title: 'Message', type: 'htmleditor', required: true, value: getTemplate(), visible: showCustomMessageField },
    ];

    if(!single && plain) {
        _.findWhere($scope.fields, {name: 'time'}).title = 'Start time';
    }

    if (getService().id) {
        reloadAvailableXStaffsForService().then(function() {
            setInitialXstaff();
        });
    }

    originalTime = _.findWhere($scope.fields, {name: 'time'}).value;
    originalTime = (single && originalTime && originalTime.hhmm)?originalTime.hhmm():null;

    $scope.$watch(getMethod, function() {
        setDueDate();
    });

    $scope.$watch(getCustomer, function() {
        var method = getMethodForCustomer(getCustomer());
        _.findWhere($scope.fields, {name: 'method'}).value = method;
        getTrainingCards();
    });

    // optional resources
    (function() {
        var optionalResourceService = $injector.get('optionalResource');

        var resources = [], bookings;
        if(options.rebook) {
            bookings = options.rbooking.siblings;
            resources = options.rbooking.service.resources;
        } else if ($scope.serviceSelected()) {
            var bookings = options.bookingParts.map(function(bp) {
                resources = bp.slot.service.resources;
                return {
                    start: getSlotStart(bp.slot),
                    end: bp.slot.end,
                    staff_id: bp.staff.id,
                    staff: bp.staff
                };
            });
        }

        if(resources.length == 0) {return;}

        var optionalResource = optionalResourceService.rebookResourceBookings({
            bookings: bookings,
            wasBooked: options.rebook,
            resources: resources
        });

        optionalResource.rooms.forEach(function(room) {
            var title;
            if(optionalResource.rooms.length > 1) {
                title = $filter('translate')('Optional resource') + ': ' + room.roomName;
            } else {
                title = 'Optional resource';
            }
            var field = {
                name: 'optional_resource__' + room.roomId,
                title: title,
                required: false,
                type: 'customers',
                value: room.chosenResources,
                itemFilter: function(i) {return _.findWhere(room.availableResources, {id: i.id});},
                itemTypes: ['staff', 'resource'],
                change: function() {
                    room.chosenResources = field.value;
                    optionalResource.refresh();
                    if ($scope.repetition.isActive()) {
                        $scope.updateRepetition();
                    }
                }
            };
            $scope.fields.push(field);

            if(options.rebook) {
                optionalResource.loadBookedByRoomId(room.roomId).then(function(chosenResources) {
                    var xstaffs = _.findWhere($scope.fields, {name: 'xstaffs'});
                    var xstaff = xstaffs.visible() && xstaffs.value;
                    field.value = room.chosenResources = chosenResources.filter(function(r) { return !xstaff || r.id != xstaff.id; });
                    optionalResource.refresh();
                });
            }
        });

        var orig_getSubmitItem = $scope.getSubmitItem;
        $scope.getSubmitItem = function() {
            var result = orig_getSubmitItem(arguments);
            result.optional_resource = optionalResource.getResult();
            return result;
        };
    })();

    // extra person
    var extraPersonField = (function() {
        var availability = 0;
        var field = {
            value: options.rebook?options.rbooking.extra_person:[],
            name: 'extra_person',
            title: 'Add person',
            type: 'extraPerson',

            newValue: '',
            addItem: function() {
                if(!field.newValue) {return;}
                if(field.available() < 1) {return;}
                field.value.push({
                    name: field.newValue
                });
                field.newValue = '';
            },
            removeItem: function(i) {
                field.value.splice(i, 1);
            },
            getCount: function() {
                return field.value && field.value.length || 0;
            },
            available: function() {
                return availability - 1 - field.value.length;
            },
            alert: function() {
                return $filter('translate')('There are {0} places left').replace('{0}', field.available());
            },
            visible: function() {
                return field.getCount() > 0 || availability > 1;
            }
        };

        $scope.fields.push(field);

        var orig_getSubmitItem = $scope.getSubmitItem;
        $scope.getSubmitItem = function() {
            var result = orig_getSubmitItem(arguments);
            result.extra_person = field.value;
            return result;
        };

        // get remnants
        function reloadRemnants() {
            if (!$scope.serviceSelected()) { return; }
            var request = {
                bookings: options.bookingParts.map(function(b) {
                    var resource_ids = _.pluck((b.slot.service || getService()).xstaffs, 'id');
                    resource_ids.push(b.staff.id);
                    return {
                        resource_ids: resource_ids,
                        start: getSlotStart(b.slot),
                        end: b.slot.end,
                        rbservice_id: (b.slot.service || getService()).id
                    };
                })
            };
            if(options.rebook) {
                request.exclude_bookings = _.pluck(options.rbooking.siblings, 'id');
            }
            server.post2('/api/resource/availability/slots/get', request).then(function(response) {
                availability = _.min(_.values(response));
            });
        }
        reloadRemnants();

        live.subscribe({
            type: 'resourcebooking',
            scope: $scope,
            callback: reloadRemnants
        });

        live.subscribe({
            type: 'workoutbooking',
            scope: $scope,
            callback: reloadRemnants
        });

        return field;
    })();

    if ($scope.serviceSelected()) {
        util.addQuestions($scope.fields, service.extendedInfo, 'extendedInfo');
        if (options.rebook) {
            var extendedInfoFields = $scope.fields.filter(function(f) { return f.name.indexOf('extendedInfo.') == 0; });
            util.setValues(extendedInfoFields, options.rbooking);
        }
    }

    $scope.bookAndPayVisibility = function() {
        return !options.rebook && $scope.hasPermission('Checkout handling') && $scope.getTotalAmount();
    };

    $scope.basket = [];
    $scope.getTotalBasketAmount = function() {
        var total = 0;
        angular.forEach($scope.basket, function(item) {
            total += Number(item.price);
        });
        return total;
    };

    function getBookingPrice() {
        if($scope.usePunchCard() || !options.bookingParts.length) {return 0;}
        var bp = firstPart;
        var card = _.find($rootScope.getActiveTrainingCards(), function(card) { return card.resourcebookingservice && (bp.slot.service || getService()).id == card.resourcebookingservice.id && card.service_base_product; });
        return card?+card.price:0;
    }

    function getServiceBaseProduct() {
        if (!options.bookingParts.length) { return null; }
        var serviceId = (firstPart.slot.service || getService()).id;
        return _.find($rootScope.getTrainingCards(), function(card) {
            return card.resourcebookingservice_id == serviceId && card.service_base_product;
        });
    }

    // The backend charges the base product regardless of its active flag, so an
    // inactive one must block the booking instead of silently pricing it at 0.
    $scope.baseProductInactive = function() {
        if ($scope.usePunchCard()) { return false; }
        var product = getServiceBaseProduct();
        return !!product && !product.active;
    };

    $scope.getTotalAmount = function() {
        var total = 0;
        if (!$scope.usePunchCard()) {
            var cards = $rootScope.getActiveTrainingCards();
            angular.forEach(options.bookingParts, function(bp) {
                var card = _.find(cards, function(card) { return card.resourcebookingservice && (bp.slot.service || getService()).id == card.resourcebookingservice.id && card.service_base_product; });
                if (card) {
                    total += Number(card.price);
                }
            });
            if ($scope.repetition.isActive()) {
                total *= ($scope.repetition.bookableSlots / options.bookingParts.length);
            }
        }

        var countExtraPersons = extraPersonField.getCount();

        return total * (1+countExtraPersons) + $scope.getTotalBasketAmount();
    };

    $scope.payment = {
        toPay: function() {
            var amount = $scope.getTotalAmount() - $scope.payment.paid() - $scope.payment.discount();
            return amount < 0?0:amount;
        },
        paid: function() {
            if(!options.rbooking || !options.rbooking.payment_details) {return 0;}
            return +options.rbooking.payment_details.paid || 0;
        },
        discount: function() {
            var bookingCount = options.bookingParts.length;
            if(!bookingCount || !options.rbooking) {return 0;}
            var discounts = options.rbooking.payment_details.discount;
            if(!discounts) {return 0;}

            var total = 0;
            var bookingPrice = getBookingPrice();
            discounts.forEach(function(d) {
                if(d.percent) {total += bookingPrice * +d.percent / 100 * bookingCount;}
                else {total += +d.amount;}
            });

            return +total;
        }
    };



    $scope.addProduct = function(product) {

        var add = function(count, variant, price) {
            var item = _.find($scope.basket, function(i) {
                if (!i.id && i.product == product && i.variant == variant) {
                    return true;
                }
            });

            if (!item) {
                item = {id: null, product: product, count: count, price: product.payWhatYouWant ? price : Number(product.price)*count, variant: variant};
                $scope.basket.push(item);
            } else {
                if (product.payWhatYouWant) {
                    item.price = price;
                    item.count = 1;
                } else {
                    item.price = Number(item.price) + Number(product.price) * count;
                    item.count += count;
                }
            }
        };

        if (product.needs_to_choose_variant() || product.payWhatYouWant) {
            $modal.open({
                templateUrl: 'views/getvariant.html',
                controller: 'GetVariantCtrl',
                resolve: {
                    options: function() {
                        return {
                            product: product,
                            basket: $scope.basket,
                            showDescription: false,
                            showCount: !product.payWhatYouWant,
                            showPrice: product.payWhatYouWant,
                            checkStock: true
                        };
                    }
                }
            }).result.then(function(result) {
                add(result.count || 1, result.variant, result.price);
            });
        } else {
            add(1);
        }
    };

    $scope.removeProduct = function(item) {
        if (item.payWhatYouWant) {
            $scope.basket.splice($scope.basket.indexOf(item), 1);
            return;
        }

        --item.count;
        item.price -= Number(item.product.price);
        if (item.id || item.count == 0) {
            $scope.basket.splice($scope.basket.indexOf(item), 1);
        }
    };

    $scope.getActiveProductsForBooking = function() {
        if (!$scope.serviceSelected()) { return []; }

        var service = getService();
        if(!service.additional_products || !service.additional_products.length) {
            return $scope.getActiveProducts();
        }
        return $scope.getActiveProducts().filter(function(product) {
            return service.additional_products.indexOf(product.id) >= 0;
        });
    };

    if (!options.customer) {
        $rootScope.getCustomerForField(_.findWhere($scope.fields, {name: 'customer'}));
    }

    if (options.rebook) {
        angular.forEach(options.rbooking.products, function(p) {
            if(options.rbooking.included_products && options.rbooking.included_products.includes(p.id)) {return;}
            var item = {
                id: p.id,
                product: p.cardtype,
                count: +p.count,
                price: +p.price,
                fullPrice: +p.price
            };
            if(p.discount) {
                item.discount = 0;
                p.discount.forEach(function(d) {
                    item.discount += -d.amount;
                    item.price += +d.amount;
                });
            }
            $scope.basket.push(item);
        });
    }

    // Repetition
    var repetition = $scope.repetition = (function() {
        var repetition = {};

        repetition.isActive = function() {
            return _.findWhere($scope.repetitionConfig.filter, { name: 'repetition' }).value;
        };
        repetition.getStartDate = function() {
            return getDate().yyyymmdd();
        };
        repetition.getEndDate = function() {
            return repetition.isActive() && _.findWhere($scope.repetitionConfig.filter, { name: 'endDate' }).value;
        };
        repetition.getInterval = function() {
            return repetition.isActive() && _.findWhere($scope.repetitionConfig.filter, { name: 'interval' }).value.id || 1;
        };
        repetition.getIntervalName = function() {
            return repetition.isActive() && _.findWhere($scope.repetitionConfig.filter, { name: 'interval' }).value.name || 'Every week';
        };
        repetition.getDay = function() {
            var startDate = _.findWhere($scope.fields, { name: 'date' }).value;
            return $filter('translate')(startDate.getWeekDayString());
        };

        repetition.time = null;
        repetition.formatTime = function() {
            if (!single) {
                repetition.time = getTime();
                return;
            }
            var service = getService();
            if (!service) { return ''; }
            var startTime = _.findWhere($scope.fields, { name: 'time' }).value;
            var endTime = startTime.clone().addMinutes(service.duration);
            repetition.time = startTime.hhmm() + ' - ' + endTime.hhmm();
        };
        repetition.formatTime();

        repetition.getBreaks = function() {
            var breaks = _.pluck(_.filter($scope.repetitionConfig.filter, function(field) { return field.name == 'break'; }), 'value');
            breaks.forEach(function(br) {
                br.from = Date.newFull(br.from);
                br.to = Date.newFull(br.to);
            });
            return breaks;
        };
        repetition.bookableSlots = 1;
        repetition.updateBookableSlots = function() {
            if (!repetition.getEndDate() || !repetition.getInterval()) {
                repetition.bookableSlots = options.bookingParts.length;
                return;
            }
            var endDate = repetition.getEndDate();
            var interval = repetition.getInterval();
            var bookableSlots = [];
            var intervalName = repetition.getIntervalName();
            var daysToAdd = intervalName === 'Every day' ? 1 : 7 * interval;

            for (var i = 0; i < options.bookingParts.length; i++) {
                var slot = options.bookingParts[i].slot;
                var nextStart = slot.start.clone();
                var nextEnd = slot.end.clone();
                var nextDate = nextStart.clone().clearTime();
                while (nextDate && endDate && nextDate <= endDate) {
                    bookableSlots.push({ start: nextStart, end: nextEnd });
                    nextStart = nextStart.clone().addDays(daysToAdd);
                    nextEnd = nextEnd.clone().addDays(daysToAdd);
                    nextDate = nextStart.clone().clearTime();
                }
            }
            bookableSlots = bookableSlots.filter(function(b) {
                return !_.find(repetition.getBreaks(), function(br) {
                    return br && Date.rangeInside(b.start, b.end, br.from, br.to);
                });
            });
            repetition.bookableSlots = bookableSlots.length - $scope.repetitionCollisions.length;
        };
        var initialUpdate = $scope.$watch(function() { return options.bookingParts; }, function() {
            if (options.bookingParts) {
                initialUpdate();
                repetition.updateBookableSlots();
            }
        }); 
        repetition.isOverlapping = function(booking) {
            var service = getService();
            if (!service) { return false; }

            var breaks = repetition.getBreaks();
            for (var i = 0; i < breaks.length; i++) {
                var br = breaks[i];
                if ((Date.newFull(br.from).getTime() <= booking.start.getTime() && booking.start.getTime() < Date.newFull(br.to).getTime())) {
                    return false;
                }
            }

            var xstaffs = _.findWhere($scope.fields, { name: 'xstaffs' });
            var xstaff_id = xstaffs.visible() && xstaffs.value && xstaffs.value.id;
            var bookingParts = _.filter(options.bookingParts, function(bp) {
                var resource_ids = [bp.staff.id];
                if (xstaff_id) {
                    resource_ids.push(xstaff_id);
                }
                var optional_resources = _.findWhere($scope.fields, { name: 'optional_resource__' + bp.staff.id });
                if (optional_resources && optional_resources.value) {
                    var optional_ids = _.uniq(_.pluck(optional_resources.value, 'id'));
                    resource_ids = resource_ids.concat(optional_ids);
                }
                for (var i = 0; i < resource_ids.length; i++) {
                    var id = resource_ids[i];
                    if (booking.origin_type == 'Workout') {
                        var wbResources = booking.staffs.concat(booking.resources);
                        if (_.findWhere(wbResources, { id: id })) {
                            return true;
                        }
                    } else {
                        if ([booking.staff_id, booking.xstaff_id, booking.optional_resource].indexOf(id) !== -1) {
                            return true;
                        }
                    }
                }
                return false;
            });

            for (var i = 0; i < bookingParts.length; i++) {
                var bp = bookingParts[i];
                var start = bp.slot.start.hhmm();
                var end = bp.slot.end.hhmm();
                
                if ((start <= booking.start.hhmm() && booking.start.hhmm() < end) || (start < booking.end.hhmm() && booking.end.hhmm() <= end)) {
                    // Create unique key for this booking part and date
                    var trackingKey = bp.staff.id + '_' + booking.start.toDateString();
                    
                    if (repetition.capacityTracker[trackingKey] === undefined) {
                        var totalCapacity = 0;
                        for (var key in bp.slot.service.staff_capacity) {
                            if (bp.slot.service.staff_capacity.hasOwnProperty(key)) {
                                totalCapacity += bp.slot.service.staff_capacity[key];
                            }
                        }
                        repetition.capacityTracker[trackingKey] = totalCapacity;
                    }
                    
                    repetition.capacityTracker[trackingKey] -= 1;
                    if (repetition.capacityTracker[trackingKey] <= 0){
                        return true;
                    }
                }
            }

            return false;
        };
        
        // Capacity tracking per booking part and date
        repetition.resetCapacityTracker = function() {
            repetition.capacityTracker = {};
        };
        repetition.resetCapacityTracker(); // Initialize
        
        repetition.hasSufficientPunchCard = function() {
            // A plain rebook reuses the returned clip(s) 1:1, which covers the booking
            // even when the depleted card is missing from the fetched card list.
            if (rebookKeepsPunchCard() && !repetition.isActive()) { return true; }
            var cards = $scope.trainingcards.filter(function(tc) {
                return tc && tc.type === 'resourcebooking' && tc.cardtype.resourcebookingservice_id === getService().id;
            });
            if (!cards.length) { return false; }
            var trainingsLeft = 0;
            cards.forEach(function(tc) { trainingsLeft += tc.trainingsLeft; });
            return repetition.bookableSlots <= trainingsLeft;
        };

        return repetition;
    })();

    // Listen for booking changes to update collision list
    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking') {
            // Update collision list when any booking changes
            if ($scope.updateRepetition && repetition && repetition.isActive && repetition.isActive()) {
                $scope.updateRepetition();
            }
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });

    var repetitionFilterVisible = function() {
        var repetitionColumn = _.findWhere($scope.repetitionConfig.filter, { name: 'repetition' });
        return repetitionColumn && repetitionColumn.value;
    };

    $scope.repetitionCollisions = [];
    $scope.updateRepetition = function() {
        repetition.resetCapacityTracker();
        repetition.formatTime();
        if (!repetitionFilterVisible()) { return; }

        var start = getDate();
        var end = $scope.repetition.getEndDate();
        var interval = $scope.repetition.getInterval();
        if (!start || !end) { return; }
        var intervalName = $scope.repetition.getIntervalName();
        var daysToAdd = intervalName === 'Every day' ? 1 : 7 * interval;

        var dates = [];
        var nextDate = start.clone().clearTime();
        end = end.clone().clearTime().addDays(1);
        while (nextDate && end && nextDate <= end) {
            dates.push(nextDate);
            nextDate = nextDate.clone();
            nextDate.addDays(daysToAdd);
        }

        if (!dates || !dates.length) { return; }
        var dateStrings = dates.map(function(d) { return d.yyyymmdd(); });

        var staff_ids = _.uniq(options.bookingParts.map(function(bp) { return bp.staff.id; }));
        var resource_ids = angular.copy(staff_ids);
        options.bookingParts.forEach(function(bp) { resource_ids.push(bp.staff.id); });
        var xstaffs = _.findWhere($scope.fields, { name: 'xstaffs' });
        var xstaff = xstaffs.visible() && xstaffs.value;
        if (xstaff) {
            resource_ids.push(xstaff.id);
        }
        staff_ids.forEach(function(resource_id) {
            var optional_resources = _.findWhere($scope.fields, { name: 'optional_resource__' + resource_id });
            if (optional_resources && optional_resources.value) {
                var ids = _.uniq(_.pluck(optional_resources.value, 'id'));
                resource_ids = resource_ids.concat(ids);
            }
        });

        server.post2('/api/resourcebooking/resource/get_resource_allocation', {
            resource_ids: resource_ids,
            start: start,
            end: end,
            mode: 'slots',
            site_id: $rootScope.selectedSite.id
        }).then(function(response) {
            var rbookings = [];
            var wbookings = [];
            response.forEach(function(data) {
                if (data.resource_booking) {
                    data.resource_booking.forEach(function(rb) {
                        rb.optional_resource = data.resource_id;
                        rbookings.push(rb);
                    });
                }
                if (data.origin_type == 'Workout') {
                    var w = data.origin;
                    w.origin_type = data.origin_type;
                    $rootScope.transformWorkout(w);
                    wbookings.push(w);
                }
            });
            $rootScope.transformResourceBookings(rbookings);

            var bookings = _.filter(rbookings.concat(wbookings), function(b) { return dateStrings.indexOf(b.start.yyyymmdd()) !== -1; });
            $scope.repetitionCollisions = _.filter(bookings, repetition.isOverlapping);
            repetition.updateBookableSlots();
        });

        var endDate = $scope.repetition.getEndDate();
        var args = {
            staffs: _.pluck(_.pluck(options.bookingParts, 'staff'), 'id'),
            fromDate: $scope.repetition.getStartDate(),
            toDate: endDate.yyyymmdd(),
            site_id: $rootScope.selectedSite.id
        };
        server.get('/api/staff/workschedule/get', args).then(function(workschedule) {
            var maxEnd = _.max(workschedule, function(ws) { return Date.newFull(ws.end).getTime(); }).end;
            maxEnd = Date.newFull(maxEnd);
            $scope.missingWorkSchedule = endDate >= maxEnd;
        });
    };

    $scope.changeBreak = function(row, initial) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'BreakTimeCtrl',
            resolve: {
                options: function() {
                    var options = { value: row.value, title: 'BREAK' };
                    if (initial) {
                        options.initial = initial;
                    }
                    return options;
                }
            }
        }).result.then(function(value) {
            row.value = value;
            if (row.change) {
                row.change();
            }
        }, function() {
            if (!row.value) {
                $scope.repetitionConfig.filter.splice($scope.repetitionConfig.filter.indexOf(row), 1);
            }
        });
    };

    $scope.addBreak = function(value) {
        var row = { name: 'break', title: 'BREAK', type: 'customobject', required: false, visible: repetitionFilterVisible, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; } };
        row.buttonClick = function() { $scope.changeBreak(row); };
        row.getName = function() {
            return formatter.format('datetimeshort', Date.newFull(row.value.from)) + ' - ' + formatter.format('datetimeshort', Date.newFull(row.value.to));
        };
        row.change = function() {
            if (row.value == null) {
                $scope.repetitionConfig.filter.splice($scope.repetitionConfig.filter.indexOf(row), 1);
            }
            $scope.updateRepetition();
        };

        var addButton = _.findWhere($scope.repetitionConfig.filter, { name: 'break_add' });
        var i = $scope.repetitionConfig.filter.indexOf(addButton);
        $scope.repetitionConfig.filter.splice(i, 0, row);

        if (!value) {
            var startDate = _.findWhere($scope.fields, { name: 'date' });
            $scope.changeBreak(row, { from: startDate && startDate.value });
        }
    };

    var showBooking = function(booking) {
        if (booking.origin_type == 'Workout') {
            $rootScope.showWorkout(booking).result.then($scope.updateRepetition);
        } else {
            $rootScope.showRBooking(booking).result.then($scope.updateRepetition);
        }
    };

    var hasItems = function() {
        return !!$scope.repetitionConfig.getItems().length;
    };

    $scope.repetitionInterval = [{id: 1, name: 'Every week'}, {id: 2, name: 'Every second week'}, {id: 3, name: 'Every third week'}, {id: 4, name: 'Every fourth week'}, {id: 5, name: 'Every day'} ];
    $scope.repetitionConfig = {
        getItems: function() {
            return repetitionFilterVisible() ? $scope.repetitionCollisions : [];
        },
        filter: [
            { name: 'repetition', title: 'Repetition', type: 'checkbox' },
            { name: 'interval', title: 'When', required: true, type: 'select', visible: repetitionFilterVisible, options: function() { return $scope.repetitionInterval; }, useId: true, value: $scope.repetitionInterval[0], change: $scope.updateRepetition },
            { name: 'endDate', title: 'End date', required: true, type: 'date', visible: repetitionFilterVisible, change: $scope.updateRepetition },
            { name: 'break_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('RB_ADD_BREAK'), click: function() { $scope.addBreak(); }, visible: repetitionFilterVisible }
        ],
        getFilterClass: function() { return 'col-lg-12'; },
        searchDepth: 2,
        hideSearch: false,
        countSuffixList: ['collision', 'collisions'],
        tableInfo: function() {
            if(hasItems()) {return 'RB_REPEATING_COLLISION_INFO';}
        },
        searchBarVisible: hasItems,
        columns: [
            { field: 'service.name', title: 'Service' },
            { field: 'name', title: 'Resource', getValue: function(b) { return b.origin_type == 'Workout' ? b.staffs[0].name : b.staff.name; } },
            { field: 'start', title: 'Date', format: 'date' },
            { field: 'start', title: 'Time', format: 'time' }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: showBooking }
        ]
    };
}]);

resourcebooking.controller('ResourceBookingModalCtrl', ['$rootScope', '$scope', '$modalInstance', '$injector', 'rbooking', '$modal','$controller', '$http', '$filter', 'server', 'confirm', 'calendar', 'optionalResource', '$modalStack', 'alertProvider', 'util', 'eventlog', 'Link',  function($rootScope, $scope, $modalInstance, $injector, rbooking, $modal, $controller, $http, $filter, server, confirm, calendar, optionalResource, $modalStack, alertProvider, util, eventlog, Link) {
    $scope.rbooking = rbooking;
    // Get bookings which are not cancelled
    var bookings = rbooking.siblings.filter(function(rb) { return !rb.cancelled; });

    $scope.getDateTitle = function() {
        var rbooking = $scope.rbooking;
        return rbooking.start.yyyymmdd() + ", " + $rootScope.getRBookingTime(rbooking);
    };

    $scope.confirm = function() {
        server.post('/api/resourcebooking/confirm', null, {booking: $scope.rbooking.id}, 'Booking confirmed', 'Failed to confirm booking').then(function(result) {
            if (result.success) {
                $scope.$close();
            }
        });
    };

    $scope.cancelling = false;
    $scope.cancel = function() {
        $scope.sendConfirmation = true;
        let opt = { sendConfirmation: true }
        var modalInstance = $modal.open({
            templateUrl: 'views/rbookingconfirmcancelmodal.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return opt;
                }
            }
        });
        modalInstance.result.then(function() {
            const args = {booking: $scope.rbooking.id, all: true, sendConfirmation: opt.sendConfirmation, sameDateOnly: true};
            server.post('/api/resourcebooking/cancel', null, args, 'Booking removed', 'Failed to remove booking').then(function(result) {
                if(result.success && result.data.alert) {
                    alertProvider.modal('Booking removed', result.data.alert);
                }
            });
        });
    };

    $scope.rebook = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/rebookrbookingmodal.html',
            controller: rbooking.service.category.multiBooking ? 'RebookResourceMultiBookingModalCtrl' : 'RebookResourceBookingModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                rbooking: function() {
                    return rbooking;
                }
            }
        });

        modalInstance.result.then(function () {
            $scope.$close();
        });
    };

    $scope.eventlog = function() {
        eventlog.openDialog({
            filter: new Link('resourcebooking', Number($scope.rbooking.id)),
            noPeriod: true,
            hideFilter: true
        });
    }

    $scope.change = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ResourceBookingChangeModalCtrl',
            resolve: {
                rbooking: function() {
                    return rbooking;
                }
            }
        });

        modalInstance.result.then(function () {
            $scope.$close();
        });
    };

    $scope.payAtCheckout = function() {
        var payments = [];
        angular.forEach($scope.rbooking.products, function(product) {
            Array.prototype.push.apply(payments, product.payments);
        });
        angular.forEach(bookings, function(booking) {
            if (booking.payment && !booking.punchcard) {
                payments.push(booking.payment);
            }
        });
        payments = payments.filter(function(p) { return p.status == 'pending'; });

        var cashiers = $injector.get('cashiers');
        var $location = $injector.get('$location');
        cashiers.transferPayments(payments);
        var ids = payments.map(function(p) { return p.id; }).filter(Boolean);
        var search = {};
        if (ids.length) search.payment_ids = ids.join(',');
        var firstPayer = payments[0] && (payments[0].payer_id || payments[0].user_id);
        if (firstPayer) search.customer_id = firstPayer;
        $location.path('/checkout').search(search);
        $modalStack.dismissAll();
    };

    $scope.closeAndGotoCustomer = function(customer) {
        $modalStack.dismissAll();
        $rootScope.gotoCustomer(customer);
    };

    $scope.closeAndGotoStaff = function(staff) {
        $modalStack.dismissAll();
        $rootScope.gotoStaff(staff);
    };

    $scope.getStaffs = function() {
        return Array.mergeSort(_.uniq(_.pluck(rbooking.siblings, 'staff')));
    };

    $scope.getIncludedProducts = function() {
        return rbooking.products.filter(function(p) {
            return rbooking.included_products.includes(p.id);
        });
    };

    $scope.getAdditionalProducts = function() {
        return rbooking.products.filter(function(p) {
            return !rbooking.included_products.includes(p.id);
        });
    };

    $scope.getTotalBasketAmount = function() {
        return $scope.getAdditionalProducts().reduce(function(total, product) {
            return total + Number(product.price);
        }, 0);
    };

    $scope.optionalResource = null;
    function loadOptionalResources() {
        optionalResource.getResourcesByBookingsPerRoom(rbooking.siblings, {excludeStaff: true}).then(function(resources) {
            $scope.optionalResource = resources.filter(function(room) {
                return !!room.resources.length;
            });
        });
    }

    loadOptionalResources();

    $scope.present = function(value) {
        server.post2('/api/resourcebooking/change_partial', {
            id: $scope.rbooking.id,
            diff: {
                present: value
            }
        }).then(function() {
            $scope.rbooking.present = value;
        });
    };

    // Multi booking calendar

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.header.left = null;
    $scope.calendarConfig.header.right = null;
    $scope.calendarConfig.defaultView = 'agendaDay';
    $scope.calendarSources = [[]];

    calendar.updateTranslation([$scope.calendarConfig]);

    // Find all staffs
    var staffs = _.uniq(_.pluck(bookings, 'staff'));
    var orderedStaffs = $filter('orderBy')(staffs, 'name');
    $scope.calendarConfig.setResources(orderedStaffs);

    // Add bookings to calendar
    angular.forEach(bookings, function(rb) {
        rb.allresources = [rb.staff];
    });
    calendar.adjustMinMax($scope.calendarConfig, bookings);
    $scope.calendarSources[0] = bookings;

    // Set date
    $scope.calendarConfig.year = $scope.rbooking.time.getFullYear();
    $scope.calendarConfig.month = $scope.rbooking.time.getMonth();
    $scope.calendarConfig.date = $scope.rbooking.time.getDate();

    // Extended info
    var service = rbooking.service;
    var setExtendedInfo = function() {
        $scope.fields = [];
        util.addQuestions($scope.fields, service.extendedInfo, '');

        util.setValues($scope.fields, rbooking.extendedInfo)
        $scope.fields.forEach(function(field) {
            field.readonly = true;
        });
    };
    setExtendedInfo();

    $scope.getBookingPrice = function() {
        var total = 0;
        angular.forEach(bookings, function(b) {
            if (!b.punchcard) {
                total += Number(b.price);
            }
        });
        return total;
    };

    $scope.getTotalAmount = function() {
        return $scope.getBookingPrice() + $scope.getTotalBasketAmount();
    };

    $scope.payment = {
        toPay: function() {
            var amount = $scope.getTotalAmount() - $scope.payment.paid() - $scope.payment.discount();
            return amount < 0?0:amount;
        },
        paid: function() {
            if(!rbooking.payment_details) {return 0;}
            return +rbooking.payment_details.paid || 0;
        },
        discount: function() {
            if(!bookings.length) {return 0;}
            var discounts = rbooking.payment_details.discount;
            if(!discounts) {return 0;}

            var total = 0;
            var bookingPrice = +bookings[0].price;
            var bookingCount = bookings.length;
            discounts.forEach(function(d) {
                if(d.percent) {total += bookingPrice * +d.percent / 100 * bookingCount;}
                else {total += d.amount;}
            });
            return +total + $scope.payment.productDiscount();
        },
        productDiscount: function() {
            var total = 0;
            rbooking.products.forEach(function(product) {
                if(product.discount) {
                    product.discount.forEach(function(d) {total += +d.amount;});
                }
            });
            return +total;
        }
    };

    $scope.getNumberOfIncludedProducts = function() {
        return $scope.getIncludedProducts().reduce(function(count, p) {
            return count + Number(p.count);
        }, 0);
    };

    $scope.getNumberOfAdditionalProducts = function() {
        return $scope.getAdditionalProducts().reduce(function(count, p) {
            return count + Number(p.count);
        }, 0);
    };

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking') {
            var me = _.findWhere(message.data, {id: rbooking.id});
            if (me) {
                rbooking.note = me.note;
                rbooking.present = me.present;
                rbooking.extendedInfo = me.extendedInfo;
                rbooking.xstaff_id = me.xstaff_id;
                rbooking.xstaff = $rootScope.getStaff(me.xstaff_id);
                setExtendedInfo();
                loadOptionalResources();
            }
        }
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
        removeServerChange();
    });
}]);

resourcebooking.controller('RebookResourceBookingModalCtrl', ['$rootScope', '$scope', '$modalInstance', '$controller', '$modal', 'rbooking', function($rootScope, $scope, $modalInstance, $controller, $modal, rbooking) {
    $controller('ResourceBookingBookCtrl', {$scope: $scope});



    $scope.rbooking = rbooking;
    $scope.calendarConfig.year = $scope.rbooking.time.getFullYear();
    $scope.calendarConfig.month = $scope.rbooking.time.getMonth();
    $scope.calendarConfig.date = $scope.rbooking.time.getDate();

    $scope.appendExtraSlots = function(slots) {
        slots.push({start: rbooking.start.clone(), end: rbooking.end.clone(), title: rbooking.title, backgroundColor: '#aaa', notClickable: true, staffs: [rbooking.staff] });
    };

    $scope.data.selectedService = rbooking.service;
    $scope.serviceChanged();

    $scope.titleSuffix = function() {
        return rbooking.service.name + ', ' + rbooking.start.yyyymmdd() + ", " + rbooking.start.hhmm() + " - " + rbooking.end.hhmm();
    };

    $scope.book = function(slot) {
        var staff = $scope.sampleStaff(slot);

        var modalInstance = $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: [{slot: slot, staff: staff}], customer: rbooking.user, rebook: true, rbooking: rbooking };
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.$close();
        });
    };
}]);

resourcebooking.controller('RebookResourceMultiBookingModalCtrl', ['$rootScope', '$scope', '$modalInstance', '$controller', '$modal', 'rbooking', function($rootScope, $scope, $modalInstance, $controller, $modal, rbooking) {
    $controller('ResourceBookingMultiBookCtrl', {$scope: $scope});

    $scope.rbooking = rbooking;
    $scope.calendarConfig.year = $scope.rbooking.time.getFullYear();
    $scope.calendarConfig.month = $scope.rbooking.time.getMonth();
    $scope.calendarConfig.date = $scope.rbooking.time.getDate();

    var setSelected = function(slots) {
        angular.forEach(rbooking.siblings, function(rb) {
            // for this rb find all slots which have the same resource, where slot-time is inside the duration of this slot time

            slots.filter(function(slot) {
                var staffOk = slot.staffs && slot.staffs.length && slot.staffs[0] == rb.staff;
                if (!staffOk) {
                    return false;
                }

                if (Date.rangeInside(slot.start, slot.end, rb.start, rb.end)) {
                    slot.selected = true;
                    $scope.setColor(slot);
                    $scope.calendarObject.fullCalendar('renderEvent', slot);
                }
            });
        });
    };

    $scope.appendExtraSlots = function(slots) {
        setSelected(slots);
    };

    $scope.getRbExcludeList = function() {
        return _.pluck(rbooking.siblings, 'id');
    };

    $scope.data.selectedService = rbooking.service;
    $scope.serviceChanged();
    $scope.category = rbooking.service.category;

    $scope.titleSuffix = function() {
        return rbooking.service.name + ', ' + rbooking.start.yyyymmdd() + ", " + rbooking.start.hhmm() + " - " + rbooking.end.hhmm();
    };

    $scope.book = function(slot) {
        var selected = $scope.getSelected();
        var bookingParts = [];
        for (var i=0; i < selected.length; ++i) {
            var slot = selected[i];
            var bp = {};
            bp.slot = slot;
            bp.staff = slot.staffs[0];
            bookingParts.push(bp);
        }

        var modalInstance = $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: bookingParts, customer: rbooking.user, rebook: true, rbooking: rbooking };
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.$close();
        });
    };
}]);

resourcebooking.controller('ResourcebookingSelectSlotModalCtrl', ['$scope', '$controller', 'rbooking', function($scope, $controller, rbooking) {
    $controller('ResourceBookingBookCtrl', {$scope: $scope});

    $scope.rbooking = rbooking;
    $scope.calendarConfig.year = $scope.rbooking.time.getFullYear();
    $scope.calendarConfig.month = $scope.rbooking.time.getMonth();
    $scope.calendarConfig.date = $scope.rbooking.time.getDate();

    $scope.appendExtraSlots = function(slots) {
        slots.push({start: rbooking.start.clone(), end: rbooking.end.clone(), title: rbooking.title, backgroundColor: '#aaa', notClickable: true, staffs: [rbooking.staff] });
    };

    $scope.data.selectedService = rbooking.service;
    $scope.serviceChanged();

    $scope.titleSuffix = function() {
        return rbooking.service.name + ', ' + rbooking.start.yyyymmdd() + ", " + rbooking.start.hhmm() + " - " + rbooking.end.hhmm();
    };

    $scope.book = function(slot) {
        $scope.$close({'data': $scope.data, 'slot': slot});
    };
}]);

resourcebooking.controller('ResourceBookingBookModalCtrl', ['$scope', '$modal', '$controller', '$filter', 'category', 'customer', function($scope, $modal, $controller, $filter, category, customer) {
    $controller('ResourceBookingBookCtrl', {$scope: $scope});

    $scope.setCategory(category);
    $scope.customer = customer;

    $scope.titleSuffix = function() {
        return customer.name + ' ' + $filter('translate')('on') + ' ' + category.name;
    };

    $scope.book = function(slot) {
        var staff = $scope.sampleStaff(slot);

        var modalInstance = $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: [{slot: slot, staff: staff}], customer: $scope.customer };
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.$close();
        });
    };
}]);

resourcebooking.controller('ResourceBookingMultiBookModalCtrl', ['$scope', '$modal', '$controller', '$filter', 'category', 'customer', function($scope, $modal, $controller, $filter, category, customer) {
    $controller('ResourceBookingMultiBookCtrl', {$scope: $scope});

    $scope.setCategory(category);

    $scope.getCustomer = function() {
        return customer;
    };

    $scope.titleSuffix = function() {
        return customer ? customer.name + ' ' + $filter('translate')('on') + ' ' + category.name : category.name;
    };

    $scope.callCloseOnSuccess = true;
}]);

resourcebooking.controller('ResourceBookingResourceAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$http', 'alertProvider', 'resourceTypes', 'server', 'genders', function($rootScope, $scope, $controller, $filter, $modal, $http, alertProvider, resourceTypes, server, genders) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = "Add resource";
    $scope.postUrl = '/api/resource/add';
    $scope.successTitle = 'Resource added';
    $scope.failedTitle = 'Failed to add resource';

    var fieldType;
    function typeIs(value) {
        return fieldType.value && fieldType.value.id === value;
    }

    var getFromAddress = function() {
        _.findWhere($scope.fields, {name: 'position'}).mapcontrol.getFromAddress(_.findWhere($scope.fields, {name: 'address'}).value, _.findWhere($scope.fields, {name: 'city'}).value);
    };

    var fetchSettings = server.get('/api/settings/get');
    var fetchPermissions = server.get('/api/staff/permissions/get').then(function(permissions) {
        permissions.forEach(function(p) {
            p.name = $filter('translate')(p.id);
        });
        $scope.permissions = permissions;
        return permissions;
    });

    // https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    $scope.submit = function() {
        var f = _.findWhere($scope.fields, {name: 'image'});
        var s = f.selection;
        var file = f.value;
        var item = $scope.getSubmitItem();
        item.qrcode_entry_id = $scope.qrcodeString;
        if (item.resourceType == 'qrcode_entry' || _.findWhere($scope.fields, {name: 'connect_qrcode_entry'}).value) {
            s = {x1: 0, y1: 0, x2: 250, y2: 250, width: 250, height: 250};
            var element = angular.element(document.querySelector('qr > img')).context.getAttribute('ng-src');
            var block = element.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            file = blob;
        }
        delete item.image;

        if (item.resourceType == 'qrcode_entry') {
            item.bookableForCustomer = false;
        }
        if (item.resourceType == 'metralockercluster') {
            item.bookableForCustomer = false;
            item.externaldoorid = `${item.metraItem}:${item.metraLocation}`;
        }
        if (item.site) {
            item.sites = [item.site];
            delete item.site;
        }
        $http.post($scope.postUrl, item).success(function(data) {
            $scope.resetForm($scope);
            alertProvider.show('success', $scope.successTitle);
            var newItem = data;

            if (file) {
                var fd = new FormData();
                fd.append('file', file);
                $http.post('/api/image/set' + '?type=Staff' + '&id=' + data.id + '&x=' + s.x1 + '&y=' + s.y1 + '&w=' + s.width + '&h=' + s.height, fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).success(function() {
                    alertProvider.show('success', 'The image was uploaded correctly');
                    $scope.possiblyClose(newItem);
                    // FIXME: Spinner
                }).error(function () {
                    alertProvider.show('error', 'The image could not be uploaded');
                    $scope.possiblyClose(newItem);
                });
            } else {
                $scope.possiblyClose(newItem);
            }
        }).error(function() {
            alertProvider.show('error', $scope.failedTitle);
        });
    };

    var isLocation = function() {
        return typeIs('location');
    };

    var isDoor = function() {
        return typeIs('door');
    };

    var genderOptions = genders.getList().map(function(o) { return {id: o.id, name: $filter('translate')(o.name)}; });

    var hasExternalDoorId = function() {
        var id = _.findWhere($scope.fields, {name: 'externaldoorid'}).value;
        return !!id;
    };

    var getResourceType = function(field) {
        return field.value.id;
    };

    var isBookable = function() {
        return _.findWhere($scope.fields, {name: 'bookableForCustomer'}).value;
    };

    var isLocationOrDoor = function() {
        var position_toggle = _.findWhere($scope.fields, {name: 'position_toggle'});
        return isLocation() || (isDoor() && (position_toggle && position_toggle.value));
    };

    var isQRCode = function() {
        return typeIs('qrcode_entry');
    };

    var isMultiResource = function() {
        return typeIs('multiresource');
    };

    var isMetraLockerCluster = function() {
        return typeIs('metralockercluster');
    }

    var multiResourceItemFilter = function(r) {
        if (r.type !== 'resource') { return false; }
        var site = _.findWhere($scope.fields, { name: 'site' });
        if (!site.value) { return true; }
        site = site.value.id;
        return r.sites.indexOf(site) !== -1;
    };

    $scope.qrcodeString = '';
    var setResourceType = function() {
        if (isQRCode() || isDoor()) {
            var rs1 = Math.random().toString(36).substr(2, 8);
            var rs2 = Math.random().toString(36).substr(2, 8);
            var rs3 = Math.random().toString(36).substr(2, 8);
            var randomString = rs1 + rs2 + rs3;
            $scope.qrcodeString = randomString;
        }
    };

    $scope.fields = [
        {name: 'lastname', title: 'Name', required: true, type: 'text'},
        {name: 'resourceType', title: 'Type', required: true, type: 'select', options: resourceTypes.get, placeholder: 'Choose type', getValue: getResourceType, change: setResourceType },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'},  
        {name: 'site', title: 'Site', required: true, type: 'select', visible: function() { return $rootScope.hasModule('MultiSite') && isMultiResource(); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
        {name: 'connected_resources', title: 'Connected resources', type: 'customers', itemTypes: ['resource'], itemFilter: multiResourceItemFilter, required: true, visible: isMultiResource },
        {name: 'bookableForCustomer', title: 'Bookable for customer', required: true, visible: function() { return !isQRCode() && !typeIs('schedule') && !isMetraLockerCluster(); }, type: 'checkbox'},
        {name: 'bookingMail', title: 'Mail on new booking', required: false, visible: function() { return isBookable() && !isQRCode() && !typeIs('schedule'); }, type: 'email'},
        {name: 'printer_id', title: 'Printer', type: 'select', options: function() { return $rootScope.printers; }, useId: true, visible: function() { return isDoor() || isQRCode(); } },
        {name: 'image', title: 'Image_title', required: false, type: 'image', visible: function() { return !isDoor() && !isQRCode() && !typeIs('schedule') && !isMetraLockerCluster(); } },
        {name: 'connect_qrcode_entry', title: 'Connect QR-code', type: 'checkbox', required: false, visible: function() { return isDoor(); } },
        {name: 'qrcode', title: 'QR-code', type: 'qrcode', image: true, visible: function(){ return isQRCode() || isDoor() && _.findWhere($scope.fields, {name: 'connect_qrcode_entry'}).value; } },
        {name: 'position_toggle', title: 'Position?', visible: isDoor, type: 'checkbox'},
        {name: 'address', title: 'Address', visible: isLocationOrDoor, required: isDoor, type: 'text' },
        {name: 'city', title: 'City', visible: isLocationOrDoor, required: isDoor, type: 'text' },
        {name: 'position', title: 'Position', visible: isLocationOrDoor, required: isDoor, type: 'map', mapcontrol: {}, getFromAddress: getFromAddress },
        {name: 'max_distance_to_door', title: 'Allowed maximal distance to open the door', helpText: 'MAX_DISTANCE_HELPTEXT', type: 'infoNumber', info: 'meter', visible: isLocationOrDoor, required: isDoor },
        {name: 'extraInfo', title: 'Internal note', required: false, type: 'htmleditor'},
        {name: 'description', title: 'Description', required: false, type: 'htmleditor', visible: function() { return !isQRCode() && !typeIs('schedule'); } },
        {name: 'externaldoorid', title: 'External door id', required: false, type: 'text', visible: isDoor, helpText: 'EXTERNAL_DOOR_ID_HELPTEXT' },
        {hint: 'The door will not open if the external door ID is not correctly specified.', visible: isDoor },
        {name: 'metraItem', title: 'Metra item', required: false, type: 'text', visible: isMetraLockerCluster },
        {name: 'metraLocation', title: 'Metra location', required: false, type: 'text', visible: isMetraLockerCluster },
        {name: 'open_door_permission', title: 'Open door with phone permission', required: false, type: 'select', options: function() { return $scope.permissions; },  visible: function() { return $rootScope.extendedTidomatIntegration && isDoor() && hasExternalDoorId(); }, useId: true, placeholder: 'Valid entry card' },
        {name: 'deductCard', title: 'Deduct card on entry', required: false, type: 'checkbox', visible: function() { return isDoor() || isQRCode(); } },
        {name: 'allowed_entry_genders', title: 'Restrict entry by gender', required: false, type: 'multiselect', visible: isDoor, options: function() { return genderOptions; }, useId: true, placeholder: 'All genders allowed'},
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite') && !isMultiResource(); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
        {name: 'capacity', title: 'Capacity', required: false, type: 'number', visible: function() { return $rootScope.hasModule('ResourceBooking') && !isDoor() && !isQRCode() && !isMultiResource() && !typeIs('schedule') && !isMetraLockerCluster(); } }
    ];

    fieldType = _.findWhere($scope.fields, {name: 'resourceType'});

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'bookableForCustomer'}).value = true;
    };

    function getMapControl() {
        return !!_.findWhere($scope.fields, {name: 'position'}).mapcontrol.getFromAddress;
    }

    var waitForMap = $scope.$watch(getMapControl, function(newValue) {
        if (newValue) {
            fetchSettings.then(function(settings) {
                if (settings.city && settings.address) {
                    _.findWhere($scope.fields, {name: 'city'}).value = settings.city;
                    _.findWhere($scope.fields, {name: 'address'}).value = settings.address;
                    getFromAddress();
                }
            });

            waitForMap();
        }
    });

    fetchPermissions.then(function() {
        $scope.setInitialValues();
    });
}]);

resourcebooking.controller('ResourceBookingResourceAddModalCtrl', ['$rootScope', '$scope', '$controller', 'options', function($rootScope, $scope, $controller, options) {
    $controller('ResourceBookingResourceAddCtrl', {$scope: $scope});
    $scope.callCloseOnSuccess = true;

    _.findWhere($scope.fields, {name: 'sites'}).value = [$rootScope.selectedSite];
    _.findWhere($scope.fields, {name: 'site'}).value = $rootScope.selectedSite;
    _.findWhere($scope.fields, {name: 'externaldoorid'}).value = options.externaldoorid;
    _.findWhere($scope.fields, {name: 'resourceType'}).value = options.resourceType;
    _.findWhere($scope.fields, {name: 'lastname'}).value = options.name;
}]);

resourcebooking.controller('ResourceBookingResourceListCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$http', 'formatter', 'resourceTypes', 'server', function($rootScope, $scope, $controller, $filter, $modal, $http, formatter, resourceTypes, server) {
    $scope.change = function(resource) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ResourceBookingResourceChangeModalCtrl',
            resolve: {
                resource: function() {
                    return resource;
                }
            }
        });
    };

    $scope.inactivateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/inactivate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: false};
            server.post(postUrl, data, null, '{0} was inactivated', 'Failed to inactivate {0}', title);
        });
    };

    $scope.activateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: true};
            server.post(postUrl, data, null, '{0} was activated', 'Failed to activate {0}', title);
        });
    };

    function inactivate(r) {
        $scope.inactivateModal(r, r.name, 'REMOVE_RESOURCEBOOKINGRESOURCE_MESSAGE', '/api/resource/change');
    }

    function activate(r) {
        $scope.activateModal(r, r.name, 'ACTIVATE_RESOURCEBOOKINGRESOURCE_MESSAGE', '/api/resource/change');
    }

    function getResourceType(r) {
        return $filter('translate')(_.findWhere(resourceTypes.getAll(), {id: r.resourceType}).name);
    }

    function add() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResourceBookingResourceAddModalCtrl',
            resolve: {
                options: function() {
                    return {};
                }
            }
        });
    }

    function isForCurrentSite(r) {
        return !$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && r.sites.indexOf($rootScope.selectedSite.id) != -1);
    }

    $scope.opening = {};
    $scope.open = function(door) {
        $scope.opening[door.id] = true;
        server.post('/api/door/open', null, {id: door.id, admin_entry: true}).then(function() {
            $scope.opening[door.id] = false;
        });
    };

    $scope.config = {
        getItems: function() {
            return $rootScope.staffs.filter(function(r) { return r.type == 'resource' && isForCurrentSite(r); });
        },
        triggers: ['user', 'image'],
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(r) { return r.active; } },
            { name: 'Inactive', itemFilter: function(r) { return !r.active; } }
        ],
        countSuffix: function() {
            return $filter('translate')('resources');
        },
        rowClick: $rootScope.gotoStaff,
        columns: [
            {field: 'image', title: '', src: $rootScope.smallStaffImage },
            {field: 'lastname', title: 'Name'},
            {field: 'resourceType', title: 'Type', getValue: getResourceType},
            {field: 'bookableForCustomer', title: 'Bookable for customer', format: 'bool'}
        ],
        orderColumn: 'lastname',
        buttons: [
            {title: 'Open', onClick: $scope.open, buttonClass: 'btn-success', visible: function(r) {return r.active && r.resourceType == 'door' && r.externaldoorid && $rootScope.hasModule('MobileEntry'); }, loading: function(door) { return door && $scope.opening[door.id];}},
            {title: 'Change', onClick: $scope.change, buttonClass: 'btn-warning', visible: function(r) {return r.active; }},
            {title: 'Activate', onClick: activate, buttonClass: 'btn-success', visible: function(r) {return !r.active; }},
            {title: 'Inactivate', onClick: inactivate, buttonClass: 'btn-danger', visible: function(r) {return r.active; }}
        ],
        searchButtons: [
            { title: 'Add', onClick: add, visible: function() { return $rootScope.hasPermission('Settings'); }, showOnEmpty: true }
        ]
    };

    if ($rootScope.speedy) {
        $scope.config.api = {
            url: '/api/resource/get',
            args: {
                site_id: () => $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null,
                inactive: true
            },
            triggers: [{type: 'user'}, {type: 'image'}, {type: 'selectedSite'}],
            transform: r => {
                r.active = r.inuse;
                r.resource = true;
                r.sites = (r.sites || []).map(s => s?.id ?? s);
            }
        }
        delete $scope.config.getItems;
        delete $scope.config.triggers;
    } else {
        $scope.pubsub('selectedSite', function() {
            if ($scope.config.control) {
                $scope.config.control.rebuild();
            }
        });
    }
}]);

resourcebooking.controller('ResourceBookingResourceChangeModalCtrl', ['$rootScope', '$scope', '$modalInstance', 'resource', '$modal', '$controller', '$filter', 'resourceTypes', 'server', '$http', 'alertProvider', 'genders', function($rootScope, $scope, $modalInstance, resource, $modal, $controller, $filter, resourceTypes, server, $http, alertProvider, genders) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.resource = resource;
    $scope.item = resource;
    $scope.postUrl = '/api/resource/change';
    $scope.successTitle = 'Resource changed';
    $scope.failedTitle = 'Failed to change resource';

    var fetchPermissions = server.get('/api/staff/permissions/get').then(function(permissions) {
        permissions.forEach(function(p) {
            p.name = $filter('translate')(p.id);
        });
        $scope.permissions = permissions;
        return permissions;
    });

    $scope.titleSuffix = function() {
        return $scope.resource.name;
    };

    var isLocation = function() {
        var type = _.findWhere($scope.fields, {name: 'resourceType'});
        if(type) {
            return type.value && type.value.id == 'location';
        }
        return false;
    };

    var isDoor = function() {
        var type = _.findWhere($scope.fields, {name: 'resourceType'});
        if(type) {
            return type.value && type.value.id == 'door';
        }
        return false;
    };

    var genderOptions = genders.getList().map(function(o) { return {id: o.id, name: $filter('translate')(o.name)}; });

    var hasExternalDoorId = function() {
        var id = _.findWhere($scope.fields, {name: 'externaldoorid'}).value;
        return !!id;
    };

    $scope.qrcodeString = $scope.resource.qrcode_entry_id ? $scope.resource.qrcode_entry_id : '';
    var setResourceType = function() {
        if (!$scope.qrcodeString) {
            var rs1 = Math.random().toString(36).substr(2, 8);
            var rs2 = Math.random().toString(36).substr(2, 8);
            var rs3 = Math.random().toString(36).substr(2, 8);
            var randomString = rs1 + rs2 + rs3;
            $scope.qrcodeString = randomString;
        }
        return _.findWhere(resourceTypes.getAll(), {id: $scope.resource.resourceType});
    };

    var getResourceType = function(field) {
        return field.value.id;
    };

    var isBookable = function() {
        return _.findWhere($scope.fields, {name: 'bookableForCustomer'}).value;
    };

    var getFromAddress = function() {
        _.findWhere($scope.fields, {name: 'position'}).mapcontrol.getFromAddress(_.findWhere($scope.fields, {name: 'address'}).value, _.findWhere($scope.fields, {name: 'city'}).value);
    };

    var isLocationOrDoor = function() {
        var position_toggle = _.findWhere($scope.fields, {name: 'position_toggle'});
        return isLocation() || (isDoor() && (position_toggle && position_toggle.value));
    };

    var whenPositionButtonToggle = function() {
        var position_toggle = _.findWhere($scope.fields, {name: 'position_toggle'});

        if(position_toggle) {
            if(position_toggle.value) {
                _.findWhere($scope.fields, {name: 'address'}).value = $scope.resource.address;
                _.findWhere($scope.fields, {name: 'city'}).value = $scope.resource.city;
                _.findWhere($scope.fields, {name: 'position'}).value = $scope.resource.position;
            } else {
                _.findWhere($scope.fields, {name: 'address'}).value = null;
                _.findWhere($scope.fields, {name: 'city'}).value = null;
                _.findWhere($scope.fields, {name: 'position'}).value = null;
            }
        }
    };

    $scope.setPositionToggle = function(resource) {
        if(resource.position) {
            _.findWhere($scope.fields, {name: 'position_toggle'}).value = true;
        }
    };

    var old = $scope.valuesChanged;
    $scope.valuesChanged = function() {
        var oldCheck = old();

        var address =_.findWhere($scope.fields, {name: 'address'}).value;
        var city = _.findWhere($scope.fields, {name: 'city'}).value;
        var position = _.findWhere($scope.fields, {name: 'position'}).value;
        if(address != $scope.resource.address || city != $scope.resource.city || position != $scope.resource.position) {
            return true;
        }
        if ($scope.qrcodeString !== resource.qrcode_entry_id) { return true; }
        return oldCheck;
    };

    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    var getQRCodeImage = function() {
        var element = angular.element(document.querySelector('qr > img')).context.getAttribute('ng-src');
        var block = element.split(";");
        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];
        var blob = b64toBlob(realData, contentType);
        return blob;
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        var file;

        if (item.resourceType === 'door' && !item.position_toggle) {
            item.address = null;
            item.city = null;
            item.position = null;
        }
        delete item.position_toggle;

        if (item.resourceType === 'qrcode_entry' || (item.resourceType === 'door' && item.connect_qrcode_entry)) {
            item.qrcode_entry_id = $scope.qrcodeString;
            file = getQRCodeImage();
        } else {
            item.qrcode_entry_id = null;
            item.connect_qrcode_entry = false;
            if ($scope.resource.resourceType === 'qrcode_entry' || $scope.resource.resourceType === 'door') {
                item.imagekey = null;
            }
        }
        if (item.resourceType == 'metralockercluster') {
            item.externaldoorid = `${item.metraItem}:${item.metraLocation}`;
        }
        if (item.site) {
            item.sites = [item.site];
            delete item.site;
        }

        $http.post($scope.postUrl, item).success(function(data) {
            alertProvider.show('success', $scope.successTitle);
            var newItem = data;

            if (file) {
                var fd = new FormData();
                fd.append('file', file);
                var s = {x1: 0, y1: 0, x2: 250, y2: 250, width: 250, height: 250};
                $http.post('/api/image/set' + '?type=Staff' + '&id=' + data.id + '&x=' + s.x1 + '&y=' + s.y1 + '&w=' + s.width + '&h=' + s.height, fd, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                }).success(function() {
                    alertProvider.show('success', 'The image was uploaded correctly');
                    $scope.possiblyClose(newItem);
                }).error(function () {
                    alertProvider.show('error', 'The image could not be uploaded');
                    $scope.possiblyClose(newItem);
                });
            } else {
                $scope.possiblyClose(newItem);
            }
        }).error(function() {
            alertProvider.show('error', $scope.failedTitle);
        });
    };

    var isQRCode = function() {
        var type = _.findWhere($scope.fields, {name: 'resourceType'});
        if(type) {
            return type.value && type.value.id == 'qrcode_entry';
        }
        return false;
    };

    var isMultiResource = function() {
        var type = _.findWhere($scope.fields, {name: 'resourceType'});
        if (type) {
            return type.value && type.value.id == 'multiresource';
        }
        return false;
    };

    var isMetraLockerCluster = function() {
        var type = _.findWhere($scope.fields, {name: 'resourceType'});
        if (type) {
            return type.value && type.value.id == 'metralockercluster';
        }
        return false;
    }

    var multiResourceItemFilter = function(r) {
        if (r.type !== 'resource') { return false; }
        if (r.id === $scope.resource.id) { return false; }
        var site = _.findWhere($scope.fields, { name: 'site' });
        if (!site.value) { return true; }
        site = site.value.id;
        return r.sites.indexOf(site) !== -1;
    };

    var setSingleSite = function() {
        return _.findWhere($rootScope.sites, { id: $scope.resource.sites[0] });
    };

    $scope.fields = [
        {name: 'lastname', title: 'Name', required: true, type: 'text'},
        {name: 'resourceType', title: 'Type', required: true, type: 'select', options: resourceTypes.get, placeholder: 'Choose type', setValue: setResourceType, getValue: getResourceType },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'},       
        {name: 'site', title: 'Site', required: true, type: 'select', visible: function() { return $rootScope.hasModule('MultiSite') && isMultiResource(); }, options: function() { return $rootScope.sites; }, setValue: setSingleSite, placeholder: 'Choose site', useId: true },
        {name: 'connected_resources', title: 'Connected resources', type: 'customers', itemTypes: ['resource'], itemFilter: multiResourceItemFilter, required: true, visible: isMultiResource },
        {name: 'bookableForCustomer', title: 'Bookable for customer', type: 'checkbox', visible: function() { return !isQRCode() && !isMetraLockerCluster(); }},
        {name: 'bookingMail', title: 'Mail on new booking', required: false, visible: isBookable, type: 'email'},
        {name: 'printer_id', title: 'Printer', type: 'select', options: function() { return $rootScope.printers; }, useId: true, visible: isDoor },
        {hint: 'RESOURCEPOSITIONHINT', visible: isLocation },
        {hint: 'If you check the position field, then it will be required that the member is nearby the door to be able to open with the mobile', visible: isDoor },
        {name: 'position_toggle', title: 'Position?', visible: isDoor, type: 'checkbox', change: whenPositionButtonToggle, helpText: 'If you check the position field, then it will be required that the member is nearby the door to be able to open with the mobile' },
        {name: 'address', title: 'Address', visible: isLocationOrDoor, required: isDoor, type: 'text' },
        {name: 'city', title: 'City', visible: isLocationOrDoor, required: isDoor, type: 'text' },
        {name: 'position', title: 'Position', visible: isLocationOrDoor, required: isDoor, type: 'map', mapcontrol: {}, getFromAddress: getFromAddress },
        {name: 'max_distance_to_door', title: 'Allowed maximal distance to open the door', helpText: 'MAX_DISTANCE_HELPTEXT', type: 'infoNumber', info:'meter', visible: isLocationOrDoor, required: isDoor },
        {name: 'extraInfo', title: 'Internal note', required: false, type: 'htmleditor'},
        {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
        {name: 'externaldoorid', title: 'External door id', required: false, type: 'text', visible: isDoor, helpText: 'EXTERNAL_DOOR_ID_HELPTEXT' },
        {hint: 'The door will not open if the external door ID is not correctly specified.', visible: isDoor },
        {name: 'metraItem', title: 'Metra item', required: false, type: 'text', visible: isMetraLockerCluster },
        {name: 'metraLocation', title: 'Metra location', required: false, type: 'text', visible: isMetraLockerCluster },
        {name: 'open_door_permission', title: 'Open door with phone permission', required: false, type: 'select', options: function() { return $scope.permissions; },  visible: function() { return $rootScope.extendedTidomatIntegration && isDoor() && hasExternalDoorId(); }, useId: true, placeholder: 'Valid entry card' },
        {name: 'connect_qrcode_entry', title: 'Connect QR-code', type: 'checkbox', required: false, visible: function() { return isDoor(); } },
        {name: 'qrcode', title: 'QR-code', type: 'qrcode', image: true, visible: function(){ return isDoor() && _.findWhere($scope.fields, {name: 'connect_qrcode_entry'}).value || isQRCode(); } },
        {name: 'deductCard', title: 'Deduct card on entry', required: false, type: 'checkbox', visible: function() { return isDoor() || isQRCode(); } },
        {name: 'allowed_entry_genders', title: 'Restrict entry by gender', required: false, type: 'multiselect', visible: isDoor, options: function() { return genderOptions; }, useId: true, placeholder: 'All genders allowed'},
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite') && !isMultiResource(); }, options: function() { return $rootScope.sites; }, placeholder: 'Choose site', useId: true },
        {name: 'capacity', title: 'Capacity', min: '1',hint: 'Recommend to inactivate resource', required: false, placeholder: '1', type: 'number', visible: function() { return $rootScope.hasModule('ResourceBooking') && !isDoor() && !isQRCode() && !isMultiResource() && !isMetraLockerCluster(); } }
    ];

    fetchPermissions.then(function() {
        $scope.setValues($scope.resource);
        $scope.setPositionToggle($scope.resource);
        if (isMetraLockerCluster()) {
            _.findWhere($scope.fields, {name: 'metraItem'}).value = $scope.resource.externaldoorid.split(':')[0];
            _.findWhere($scope.fields, {name: 'metraLocation'}).value = $scope.resource.externaldoorid.split(':')[1];
        }
    });
}]);

resourcebooking.controller('ResourceBookingResourceAvailibilityCtrl', ['$rootScope', '$scope', '$http', '$modal', 'calendar', 'server', function($rootScope, $scope, $http, $modal, calendar, server) {

    $scope.setAvailibility = function() {
        $modal.open({
            templateUrl: 'views/setavailibility.html',
            controller: 'WorkScheduleAddModalCtrl',
            resolve: {
                options: function() {
                    return {
                        staffs: $rootScope.getActiveResources(),
                        selected: $scope.selectedResources,
                        successTitle: 'Availibility changed',
                        failedTitle: 'Failed to change availibility'
                    };
                }
            }
        });
    };

    $scope.changeAvailibility = function(day) {
        $modal.open({
            templateUrl: 'views/changeavailibility.html',
            controller: 'WorkScheduleChangeModalCtrl',
            resolve: {
                options: function() {
                    return {
                        staffs: $rootScope.getActiveResources(),
                        selected: $scope.selectedResources,
                        fromDate: day,
                        successTitle: 'Availibility changed',
                        failedTitle: 'Failed to change availibility'
                    };
                }
            }
        });
    };

    $scope.getWorkSchedules = function() {
        if ($scope.visStart && $scope.selectedResources) {
            $scope.calendarSources[0] = [];

            if ($scope.selectedResources.length > 0) {
                var ids = _.pluck($scope.selectedResources, 'id').filter(id => id).join(',');
                if (ids) {
                    $http.get('/api/staff/workschedule/get?staffs=' + ids + '&fromDate=' + $scope.visStart.yyyymmdd() + '&toDate=' + $scope.visEnd.yyyymmdd() + '&site_id=' + $rootScope.selectedSite.id).success(function(workschedule) {
                    angular.forEach(workschedule, function(t) {
                        t.start = Date.newFull(t.start);
                        t.end = Date.newFull(t.end);
                        t.backgroundColor = 'rgba(99, 166, 99, 0.5)';
                        t.title = '';
                        t.isAnnotation = true;
                        t.showPointer = true;
                    });

                    calendar.adjustMinMax($scope.calendarConfig, workschedule);

                    $scope.calendarSources[0] = workschedule;
                    });
                }
            }
        }
    };

    $scope.selectedResourcesChanged = function() {
        $scope.selectedResources = _.findWhere($scope.fields, {name: 'staffs'}).value;
        $scope.getWorkSchedules();
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    calendar.removeMonth($scope.calendarConfig);
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view)) {
            $scope.getWorkSchedules();
        }
    };

    $scope.calendarConfig.eventClick = function(calEvent) {
        $scope.changeAvailibility(calEvent.start.clone());
    };

    $scope.forCurrentSite = function(r) {
        return !$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && r.sites.indexOf($rootScope.selectedSite.id) != -1);
    };

    $scope.calendarSources = [[]];

    // FIXME: Move this to calendar module
    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        // Manually update stuff for this particular staff
        var fetchWorkSchedule = false;
        if (message.type == 'workschedule') {
            angular.forEach(message.data, function(messageData) {
                var staff = $rootScope.getStaff(messageData.staff);
                if (staff && staff.resource) {
                    fetchWorkSchedule = true;
                }
            });
        }

        if (fetchWorkSchedule) {
            $scope.getWorkSchedules();
        }
    });


    calendar.updateTranslation([$scope.calendarConfig]);

    function updateResourcesAndSchedules() {
        if ($rootScope.speedy) {
            server.get('/api/resource/get', {site_id: $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null}).then(resources => {
                $scope.selectedResources = resources;
                _.findWhere($scope.fields, {name: 'staffs'}).value = $scope.selectedResources;
                $scope.getWorkSchedules();
            });
        } else {
            $scope.selectedResources = $rootScope.getActiveResources().filter($scope.forCurrentSite);
            _.findWhere($scope.fields, {name: 'staffs'}).value = $scope.selectedResources;
            $scope.getWorkSchedules();
        }
    }

    $rootScope.waitFor(['staffs', 'sites']).then(updateResourcesAndSchedules);
    $scope.pubsub('selectedSite', updateResourcesAndSchedules);

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
        removeServerChange();
    });

    $scope.fields = [
        {name: 'staffs', title: 'Resources', required: false, type: 'customers', itemTypes: ['resource'], change: $scope.selectedResourcesChanged }
    ];
    $scope.noFormValidation = true;
    $scope.hideSubmitButton = true;

}]);

resourcebooking.controller('ResourceCtrl', ['$scope', '$controller', '$modal', 'fileManager', function($scope, $controller, $modal, fileManager) {
    $controller('StaffCtrl', {$scope: $scope});

    $scope.change = function() {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ResourceBookingResourceChangeModalCtrl',
            resolve: {
                resource: function() {
                    return $scope.staff;
                }
            }
        });
    };

    $scope.openFileManager = function() {
        fileManager.open({
            originId: $scope.staff.id,
            originType: 'staff',
            visibleTabs: ['files', 'all']
        });
    };
}]);

resourcebooking.controller('SettingsResourceBookingCtrl', ['$rootScope', '$scope', '$route', '$controller', 'server', '$modal', function($rootScope, $scope, $route, $controller, server, $modal) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/resourcebooking/settings/get';
    $scope.postUrl = '/api/resourcebooking/settings/set';

    var openResourceBookingReminderMailTemplate = function(item) {
        server.get('/api/mailing/automailing/get', {autoType: 'RESOURCE_BOOKING_REMINDER'}).then(function(result) {
            if (item.name === 'reminderMail') {
                result = result.emailTemplate;
            } else {
                result = result.SMSTemplate;
            }
            $modal.open({
                templateUrl: 'views/templateschange.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplateChangeCtrl',
                resolve: {
                    template: function() {
                        return result;
                    }
                }
            });
        });
    };

    var openResourceBookingReminderAutomaticMailing = function() {
        server.get('/api/mailing/automailing/get', {autoType: 'RESOURCE_BOOKING_REMINDER'}).then(function(result) {
            $modal.open({
                templateUrl: 'views/automailingschange.html',
                windowClass: 'huge-modal-window',
                controller: 'AutomaticMailingChangeCtrl',
                resolve: {
                    autoMailing: function() {
                        return result;
                    }
                }
            });
        });
    };

    $scope.fields = [
        {name: 'sendBookingMailToStaff', title: 'Notify relevant staff on new booking', type: 'checkbox' },
        {name: 'sendReminderSmsOrMail', title: 'Send reminder SMS or mail to customers', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openResourceBookingReminderAutomaticMailing },
        {name: 'reminderMail', title: 'Message in reminder (E-mail)', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openResourceBookingReminderMailTemplate },
        {name: 'reminderSMS', title: 'Message in reminder (SMS)', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openResourceBookingReminderMailTemplate, visible: function() { return $rootScope.hasModule('SMS'); } },
        {name: 'reminderSmsHours', title: 'Send reminder', type: 'infoNumber', info: 'hours before' },
        {name: 'registerHoursBefore', title: 'Must book at least', info: 'hours before', required: true, type: 'infoNumber', min: 0},
        {name: 'unregisterHoursBefore', title: 'Must cancel at least', info: 'hours before', required: true, type: 'infoNumber', min: 0},
        {name: 'advancedResourcePlanning', title: 'Advanced resource planning', type: 'checkbox' }
    ];

    $scope.getSettings();
}]);

resourcebooking.controller('ResourceBookingUnconfirmedCtrl', ['$rootScope', '$scope', 'server', 'confirm', 'alertProvider', 'live', 'options', function($rootScope, $scope, server, confirm, alertProvider, live, options) {

    options = options || {};

    var confirmBooking = function(rb) {
        server.post('/api/resourcebooking/confirm', null, {booking: rb.id}, 'Booking confirmed', 'Failed to confirm booking');
    };

    var cancelBooking = function(rb) {
        confirm.show('Are you sure you want to remove the booking?', {ladda: true}).then(function(resolve) {
            var args = {booking: rb.id};
            if (rb.parent_id) {
                args.all = true;
                args.sameDateOnly = true;
            }

            server.post('/api/resourcebooking/cancel', null, args, 'Booking removed', 'Failed to remove booking').then(function(result) {
                resolve();
                if(result.success && result.data.alert) {
                    alertProvider.modal('Booking removed', result.data.alert);
                }
            });
        });
    };

    $scope.config = {
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        api: {
            url: '/api/resourcebooking/unconfirmed/get',
            transform: $rootScope.transformResourceBooking,
            onItemsUpdated(items) {
                $rootScope.transformResourceBookings(items);
                items.filterInPlace(rb => rb.siblings[0] == rb);
            }
        },
        filter: [
            { name: 'category_id', title: 'Categories', type: 'multiselect', options: () => $rootScope.resourcebookingcategories, useId: true, placeholder: 'Show all categories' },
            { name: 'resource_id', title: 'Resources', type: 'customers', itemTypes: ['staff', 'resource'], useId: true, placeholder: 'Show all resources' }
        ],
        saveFilter: 'resourcebooking/unconfirmed',

        columns: [
            {field: 'image', src: function(rb) {return $rootScope.smallMemberImage(rb.user);} },
            {field: 'user.name', title: 'Customer' },
            {field: 'category.name', title: 'Category' },
            {field: 'staff.name', title: 'Resource' },
            {field: 'xstaff.name', title: 'Additional resource' },
            {field: 'created', title: 'Booking time', format: 'datetime'},
            {field: 'time', title: 'Date', format: 'date'}
        ],
        rowClick: function(rb) {
            $rootScope.showRBooking(rb);
        },
        buttons: [
            {title: 'Show booking', buttonClass: 'btn-info', onClick: $rootScope.showRBooking, visible: function() { return $rootScope.hasPermission('Resource booking'); } },
            {title: 'Confirm', buttonClass: 'btn-success', onClick: confirmBooking, visible: function() { return $rootScope.hasPermission('Resource booking'); } },
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', onClick: cancelBooking, visible: function() { return $rootScope.hasPermission('Resource booking'); } }
        ]
    };

    if (options.config) {
        _.deep_extend($scope.config, options.config);
    }

    live.subscribe({
        type: 'resourcebooking',
        scope: $scope,
        callback: () => $scope.config.control.updateApi()
    });
}]);

resourcebooking.controller('ResourceBookingUnconfirmedMasterCtrl', ['$rootScope', '$scope', '$http', function($rootScope, $scope, $http) {
    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        var refetchUnconfirmed = false;

        if (message.type == 'resourcebooking') {
            if (message.action == 'change' || message.action == 'remove') {
                angular.forEach(message.data, function(messageData) {
                    var match = _.findWhere($rootScope.unconfirmedResourceBookings, {id: messageData.id});
                    if (match) {
                        refetchUnconfirmed = true;
                    }
                });
            } else if (message.action == 'add') {
                angular.forEach(message.data, function(messageData) {
                    if (!messageData.confirmed) {
                        refetchUnconfirmed = true;
                    }
                });
            }
        }

        if (refetchUnconfirmed) {
            $http.get('/api/resourcebooking/unconfirmed/get').success(function(data) {
                $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                    $rootScope.transformResourceBookings(data);
                    $rootScope.unconfirmedResourceBookings = data.filter(function(rb) { return rb.siblings[0] == rb; });
                });
            });
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);

resourcebooking.factory('resourceTypes', ['$rootScope', function($rootScope) {
    var resourceTypes = {};

    var types = [
        { id: 'resource', name: 'Resource' },
        { id: 'location', name: 'Location' },
        { id: 'door', name: 'Door', modules: ['Entry'] },
        { id: 'room', name: 'Room' },
        { id: 'qrcode_entry', name: 'QR-Code entry' },
        { id: 'multiresource', name: 'Multi resource' },
        { id: 'schedule', name: 'Schedule' },
        { id: 'metralockercluster', name: 'Locker cluster - Metra', modules: ['Metra'] }
    ];

    resourceTypes.getAll = function() {
        return types;
    };

    resourceTypes.get = function() {
        return types.filter(function(t) { return _.every(t.modules, $rootScope.hasModule); });
    };

    return resourceTypes;
}]);

resourcebooking.controller('ResourceBookingChangeModalCtrl', ['$rootScope', '$scope', 'rbooking', '$controller', '$filter', 'server', '$injector', 'util', '$modal', '$q',
    function($rootScope, $scope, rbooking, $controller, $filter, server, $injector, util, $modal, $q) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = rbooking;
    $scope.selectedService = rbooking.service;
    $scope.selectedResource = rbooking.staff;
    $scope.selectedXStaff = rbooking.xstaff;
    $scope.postUrl = '/api/resourcebooking/change';

    $scope.titleSuffix = function() {
        return $filter('translate')('booking');
    };

    var availableXStaffs = null;
    var loadAvailableXStaffs = function() {
        server.post('/api/resourcebooking/service/get_free_xstaffs', null, {
            id: rbooking.service_id,
            startTime: rbooking.start.dateTime(),
            endTime: rbooking.end.dateTime(),
            staff_id: rbooking.staff_id,
            exclude: rbooking.id
        }).then(function(response) {
            availableXStaffs = response.data || [];
            var xstaffId = $scope.item.xstaff_id;
            if (xstaffId && !_.findWhere(availableXStaffs, { id: xstaffId })) {
                availableXStaffs.push($scope.item.xstaff);
            }

            var xstaffField = (_.findWhere($scope.fields, { name: 'xstaff' }) || {});
            xstaffField.required = availableXStaffs.length > 0;
            if(xstaffId) {
                xstaffField.value = _.findWhere(availableXStaffs, {id: xstaffId});
            }
        });
    };

    var reloadAvailableXStaffs = function() {
        var deffered = $q.defer();

        var service = $scope.selectedService;
        if (!service || !service.id) {
            deffered.reject();
            return deffered.promise;
        }

        var time = _.findWhere($scope.fields, { name: 'time' }).value;
        var start = time.clone();
        var end = time.clone();
        end.addMinutes(service.duration);
        server.post('/api/resourcebooking/service/get_free_xstaffs', null, {
            id: service.id,
            startTime: start.dateTime(),
            endTime: end.dateTime(),
            staff_id: $scope.selectedResource.id,
            exclude: rbooking.id
        }).then(function(response) {
            availableXStaffs = _.filter(response.data, function(xstaff) {
                return xstaff.id != $scope.selectedResource.id;
            });
            _.findWhere($scope.fields, { name: 'xstaff' }).required = availableXStaffs.length > 0;
            deffered.resolve();
        });

        return deffered.promise;
    };

    var getXStaffsForService = function() {
        return availableXStaffs;
    };

    var setRandomXstaff = function() {
        var xstaffs = getXStaffsForService();
        var item = xstaffs.length > 0 ? xstaffs[Math.floor(Math.random() * xstaffs.length)] : null;
        (_.findWhere($scope.fields, { name: 'xstaff' }) || {}).value = item;
    };

    $scope.chooseSlot = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/choosetimeslotrbookingmodal.html',
            controller: 'ResourcebookingSelectSlotModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                rbooking: function() {
                    return $scope.item;
                }
            }
        });

        modalInstance.result.then(function (result) {
            _.findWhere($scope.fields, {name: 'time'}).value  = result.slot.start;
            _.findWhere($scope.fields, {name: 'staff'}).value = $scope.selectedResource = result.slot.staffs[0];
            reloadAvailableXStaffs().then(function() {
                setRandomXstaff();
            });
        })
    };

    var changedStaff = function() {
        $scope.selectedResource = this.value;

        reloadAvailableXStaffs().then(function() {
            setRandomXstaff();
        });
    };

    var importantFieldsChanged = function() {
        var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
        fields = fields.filter((f) => ['staff', 'time'].includes(f.name));
        for (var i=0; i < fields.length; ++i) {
            var field = fields[i];
            if (util.valueChanged(field, $scope.item)) {
                return true;
            }
        }

        return false;
    };

    function isRbookingHistoric() {
        return _.findWhere($scope.fields, {name: 'time'}).value < new Date();
    }

    function showConfirmationCheckbox() {
        return  importantFieldsChanged() && !isRbookingHistoric();
    }

    function showCustomMessageCheckbox() {
        return  _.findWhere($scope.fields, {name: 'sendConfirmation'}).value && importantFieldsChanged() && !isRbookingHistoric();
    }

    function showCustomMessageField() {
        return showCustomMessageCheckbox() && _.findWhere($scope.fields, {name: 'customizeMailing'}).value && importantFieldsChanged() && !isRbookingHistoric();
    }

    function getTemplate() {
        return $scope.item.service.category.confirmTemplateRebooking ?? $filter('translate')('REBOOKING_CONFIRM_MAIL');
    }

    $scope.fields = [
        { name: 'staff', title: 'Resource', required: true, type: 'select', change: changedStaff, options: () => $scope.selectedService.staffs, visible: () => !rbooking.service.category.multiBooking, useId: true },
        { name: 'Change', type: 'button', buttonTitle: 'Choose time', buttonClass: 'btn btn-primary', click: $scope.chooseSlot, visible: () => !rbooking.service.category.multiBooking },
        { name: 'time', title: 'Start', required: true, type: 'datetime', visible: () => !rbooking.service.category.multiBooking },
        { name: 'note', title: 'Note', required: false, type: 'textarea' },
        { name: 'xstaff', title: 'Additional resource', required: true, type: 'select', options: getXStaffsForService, useId: true },
        { name: 'sendConfirmation', title: 'Send confirmation mail to customer', type: 'checkbox', setValue: () => true, visible: showConfirmationCheckbox },
        { name: 'customizeMailing', title: 'Customize mailing', type: 'checkbox', value: false, visible: showCustomMessageCheckbox },
        { name: 'customMessage', title: 'Message', type: 'htmleditor', required: true, setValue: getTemplate, visible: showCustomMessageField }
    ];
    loadAvailableXStaffs();

    // optional resources
    (function() {
        var optionalResourceService = $injector.get('optionalResource');
        var optionalResource = optionalResourceService.rebookResourceBookings({
            bookings: rbooking.siblings,
            wasBooked: true,
            resources: rbooking.service.resources
        });
        var availableResourcesForSelectedService = $scope.selectedService.resources.map(({id}) => id);

        optionalResource.rooms.forEach(function(room) {
            var title, initValue = [];
            if(optionalResource.rooms.length > 1) {
                title = $filter('translate')('Optional resource') + ': ' + room.roomName;
            } else {
                title = 'Optional resource';
            }
            var field = {
                name: 'optional_resource__' + room.roomId,
                title: title,
                required: false,
                type: 'customers',
                value: room.chosenResources,
                itemFilter: function(i) {return _.findWhere(room.availableResources, {id: i.id}) && availableResourcesForSelectedService.includes(i.id);},
                itemTypes: ['staff', 'resource'],
                change: function() {
                    room.chosenResources = field.value;
                    optionalResource.refresh();
                },
                changed: function() {
                    if(!field.value) {return false;}
                    if(field.value.length != initValue.length) {return true;}

                    var diff = {};
                    initValue.forEach(function(i) {diff[i.id] = true;});
                    return field.value.reduce(function(p, i) {
                        return p || !diff[i.id];
                    }, false);
                }
            };
            $scope.fields.push(field);

            optionalResource.loadBookedByRoomId(room.roomId).then(function(chosenResources) {
                var xstaff = _.findWhere($scope.fields, {name: 'xstaff'}).value;
                field.value = initValue = room.chosenResources = chosenResources.filter(function(r) { return !xstaff || r.id != xstaff.id; });
                optionalResource.refresh();
            });
        });

        var orig_getSubmitItem = $scope.getSubmitItem;
        $scope.getSubmitItem = function() {
            var result = orig_getSubmitItem(arguments);
            result.optional_resource = optionalResource.getResult();
            result.old_time = $scope.item.time.dateTime();
            result.old_resource = $scope.item.staff;
            result.send_confirmation = $scope.item.sendConfirmation ?? false;
            if (!rbooking.service.category.multiBooking) {
                result.optional_resource.forEach((o) => {
                    if (o.room_id == $scope.item.staff.id) {
                        o.room_id = result.staff;
                    }
                });
            }
            return result;
        };
    })();

    util.addQuestions($scope.fields, rbooking.service.extendedInfo, 'extendedInfo');

    $scope.setValues(rbooking);
}]);

resourcebooking.controller('RemoveResourceBookingServiceModalCtrl', ['$scope', '$http', 'options', function($scope, $http, options) {
    $scope.options = options;
    $scope.titleSuffix = options.title;
    $scope.content = options.content;

    if (options.getUsageUrl) {
        $http.get(options.getUsageUrl + '?id=' + options.item.id).success(function(data) {
            $scope.removedItems = [ { title: 'Punch cards', count: data.cardtypes },
                                    { title: 'Sold punch cards', count: data.cards },
                                    { title: 'Payments', count: data.payments },
                                    { title: 'GENERAL_BOOKINGS', count: data.bookings } ];
        });
    }
}]);

resourcebooking.controller('ResourceBookingOverviewCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'confirm', 'formatter', 'server', 'alertProvider', '$q', '$location', 'resourceBooking',
    function($rootScope, $scope, $controller, $modal, $filter, confirm, formatter, server, alertProvider, $q, $location, $resourceBooking) {
    $controller('AllStaffWorkScheduleCtrl', { $scope: $scope });

    $scope.title = 'Schedule';

    // $scope.calendarConfig.eventStartEditable = true;  // DEV-1876
    $scope.calendarConfig.eventStartEditable = false;
    $scope.calendarConfig.annotationDraggable = false;

    $scope.addBooking = function(slot) {
        var staff = slot.clickedResource || slot.staff;
        $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: [{slot: slot, staff: staff}], customer: null };
                }
            }
        });
    };

    var currentRbid = null;
    var currentModal = null;

    function openBookingWithUrlSync(rbid) {
        if (currentRbid === rbid) return;
        if (currentModal) {
            var prev = currentModal;
            currentModal = null;
            prev.dismiss();
        }
        currentRbid = rbid;
        if (parseInt($location.search().rbid, 10) !== rbid) {
            $location.search('rbid', rbid).replace();
        }
        $resourceBooking.openById(rbid).then(function(modal) {
            if (!modal || !modal.result) { return; }
            if (currentRbid !== rbid) {
                modal.dismiss();
                return;
            }
            currentModal = modal;
            modal.result.finally(function() {
                if (currentModal === modal) {
                    currentModal = null;
                    currentRbid = null;
                    if (parseInt($location.search().rbid, 10) === rbid) {
                        $location.search('rbid', null).replace();
                    }
                }
            });
        });
    }

    function syncRbidFromUrl() {
        var newRbid = parseInt($location.search().rbid, 10) || null;
        if (newRbid === currentRbid) return;
        if (newRbid) {
            openBookingWithUrlSync(newRbid);
        } else if (currentModal) {
            var m = currentModal;
            currentModal = null;
            currentRbid = null;
            m.dismiss();
        }
    }

    syncRbidFromUrl();
    $scope.$on('$routeUpdate', syncRbidFromUrl);

    var oldEventClick = $scope.calendarConfig.eventClick;
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            $scope.addBooking(calEvent);
            return;
        }
        var isSingleBooking = !calEvent.workoutType &&
            calEvent.resource_booking_id &&
            !calEvent.enableCapacity &&
            (!calEvent.resource_booking || calEvent.resource_booking.length === 1);
        if (isSingleBooking) {
            openBookingWithUrlSync(calEvent.resource_booking_id[0]);
            return;
        }
        oldEventClick(calEvent);
    };

    var getServicesForStaff = function(staffId) {
        return _.filter($rootScope.getActiveResourceBookingServices(), function(s) {
            return _.findWhere(s.staffs, { id: staffId });
        });
    };

    var getServiceBreakTime = function(staffId, serviceId) {
        return (_.find(getServicesForStaff(staffId), function(s) { return s.id === serviceId; }) || {}).breakafter || 0;
    };

    var targetStaffHasService = function(staffId, serviceId) {
        return _.find(getServicesForStaff(staffId), function(service) {
            return service.id == serviceId;
        }) ? true : false;
    };

    $scope.getCollisionsForEvent = function(event, startDate, endDate) {
        var bookingList = $scope.allBookedTimes.concat($scope.allWorkouts);
        startDate = startDate || event.start;
        endDate = endDate || event.end;

        var collisions = _.filter(bookingList, function(booking) {
            // Skip if not on same resource
            if (booking.staffs[0].id != event.staffs[0].id) {
                return false;
            }
            // Skip if self
            if (booking.resource_booking_id && booking.resource_booking_id[0] == event.resource_booking_id[0]) {
                return false;
            }

            var bookingEnd = booking.end;
            if (booking.rbservice_id) {
                bookingEnd = new Date(booking.end.getTime() + (getServiceBreakTime(booking.resource_id, booking.rbservice_id) * 60 * 1000));
            }

            return (booking.start.hhmm() < endDate.hhmm()) && (bookingEnd.hhmm() > startDate.hhmm());
        });

        var timeOverlaps = [];
        var breakOverlaps = [];
        for (var i = 0; i < collisions.length; i++) {
            var c = collisions[i];
            if ((c.start.hhmm() < endDate.hhmm()) && (c.end.hhmm() > startDate.hhmm())) {
                timeOverlaps.push(c);
            }
            else { breakOverlaps.push(c); }
        }

        return {
            timeOverlaps: timeOverlaps,
            breakOverlaps: breakOverlaps,
            length: (timeOverlaps.length + breakOverlaps.length)
        };
    };

    $scope.getAvailableXStaffForService = function(serviceId, fromTime, toTime) {
        var deffered = $q.defer();
        server.post('/api/resourcebooking/service/get_free_xstaffs', null, {
            id: serviceId,
            startTime: fromTime.dateTime(),
            endTime: toTime.dateTime()
        }).then(function(response) {
            deffered.resolve(response.data);
        });

        return deffered.promise;
    };

    $scope.calendarConfig.eventDrop = function(event, dayDelta, minuteDelta, allDay, revertFunc) {

        var restoreEvent = function(message) {
            alertProvider.show('error', message ? message : 'Could not rebook to selected resource', false);
            revertFunc(); // Revert event to original position
        };

        if (!targetStaffHasService(event.resource_id, event.rbservice_id)) {
            restoreEvent('Selected resource is not bookable for current service');
            return;
        }

        if (event.resource_id === event.resource_booking[0].xstaff_id) {
            restoreEvent();
            return;
        }

        var getCorrectDates = function() {
            var correctDate = $scope.calendarObject.fullCalendar('getDate').getDate();
            var correctStart = new Date(event.start.dateTime()).setDate(correctDate);
            var correctEnd = new Date(event.end.dateTime()).setDate(correctDate);
            var breakafter = getServiceBreakTime(event.resource_id, event.rbservice_id);
            var correctEndWithBreak = new Date(correctEnd + (breakafter * 60 * 1000)) || correctEnd;

            return {
                start: new Date(correctStart),
                end: new Date(correctEnd),
                breakafter: breakafter,
                endWithBreak: new Date(correctEndWithBreak)
            };
        };
        var correctDates = getCorrectDates();

        var isWithinStaffWorkhours = function(startDate, endDate) {
            startDate = startDate || correctDates.start;
            endDate = endDate || correctDates.end;

            var staffWorkSchedule = _.filter($scope.allWorkSchedules, function(schedule) {
                return schedule.start.getDate() === correctDates.start.getDate() && schedule.staff.id == event.resource_id;
            });

            for (var i = 0; i < staffWorkSchedule.length; i++) {
                var schedule = staffWorkSchedule[i];
                if (Date.rangeInside(startDate, endDate, schedule.start, schedule.end)) {
                    return true;
                }
            }
            return false;
        };

        var getRebookDataFromEvent = function(startDate, endDate) {
            var rb = event.resource_booking[0];
            return {
                id: rb.id,
                bookings: [{
                    service: event.rbservice_id,
                    start: startDate.dateTime(),
                    end: endDate.dateTime(),
                    staff: event.staffs[0].id,
                    member: rb.booker_id,
                    xstaff_id: rb.xstaff_id,
                    note: rb.note
                }]
            };
        };

        var rebookEvent = function(startDate, endDate) {
            startDate = startDate || correctDates.start;
            endDate = endDate || correctDates.end;

            var message = $filter('translate')('Confirm rebooking to time <b>{0}</b> and staff <b>{1}</b>').format(formatter.format('time', startDate), event.staffs[0].fullname);
            confirm.show(message, { ladda: true }).then(function(resolve) {
                // Rebook event
                var rebookData = getRebookDataFromEvent(startDate, endDate);
                server.post('/api/resourcebooking/rebook', rebookData, null, 'Rebook successful', 'Rebook failed')
                .then(function(response) {
                    if (!response.success) {
                        restoreEvent();
                    }
                    resolve();
                });

            }).catch(function() {
                revertFunc();
            });
        };

        if (!isWithinStaffWorkhours()) {
            restoreEvent('Could not rebook outside of set workhours');
            return;
        }

        var collisions = $scope.getCollisionsForEvent(event, correctDates.start, correctDates.endWithBreak);
        if (collisions.timeOverlaps && collisions.timeOverlaps.length > 0) {
            restoreEvent('Scheduled resource booking time or break time are overlapping');
            return;
        }

        var xstaffRebookValid = function(availableXStaffs) {
            var xstaffId = event.resource_booking[0].xstaff_id;
            if (!xstaffId) {
                return true;
            }
            return _.findWhere(availableXStaffs, { id: xstaffId });
        };

        $scope.getAvailableXStaffForService(event.rbservice_id, correctDates.start, correctDates.end).then(function(xstaffs) {

            if (minuteDelta !== 0 && !xstaffRebookValid(xstaffs)) {
                restoreEvent('Could not rebook since the additional resource is busy at the specified time');
                return;
            }

            if (collisions.breakOverlaps && collisions.breakOverlaps.length > 0) {
                var adjustmentTime = getServiceBreakTime(collisions.breakOverlaps[0].resource_id, collisions.breakOverlaps[0].rbservice_id);
                var adjustedStart = new Date(correctDates.start.getTime() + (adjustmentTime * 60 * 1000));
                var adjustedEnd = new Date(correctDates.end.getTime() + (adjustmentTime * 60 * 1000));
                var adjustedEndWithBreak = new Date(correctDates.endWithBreak.getTime() + (adjustmentTime * 60 * 1000));
                var collisionsAfterAdjustment = $scope.getCollisionsForEvent(event, adjustedStart, adjustedEndWithBreak);

                $scope.getAvailableXStaffForService(event.rbservice_id, adjustedStart, adjustedEnd).then(function(adjustedXStaffs) {

                    if (!xstaffRebookValid(adjustedXStaffs)) {
                        restoreEvent('Could not rebook since the additional resource is busy at the specified time');
                        return;
                    }

                    if (collisionsAfterAdjustment.length === 0 && isWithinStaffWorkhours(adjustedStart, adjustedEnd)) {
                        var message = $filter('translate')('ADJUST_RESOURCE_REBOOKING_MESSAGE').format(formatter.format('time', adjustedStart));
                        confirm.show(message).then(function() {
                            rebookEvent(adjustedStart, adjustedEnd);
                        }).catch(function() {
                            revertFunc();
                        });
                        return;
                    }
                    restoreEvent('Scheduled resource booking time or break time are overlapping');
                    return;
                });
            }
            else {
                rebookEvent();
            }
        });

    };

    var grayOutWorkouts = function() {
        angular.forEach($scope.allWorkouts, function(wo) {
            wo.backgroundColor = '#cccccc';
        });
    };

    $scope.$watch(function() { return $scope.allWorkouts; }, grayOutWorkouts);

    $scope.fields = [
        {name: 'staffs', title: 'Staff', required: false, type: 'customers', itemTypes: ['staff'], change: $scope.staffsChanged }
    ];
    $scope.noFormValidation = true;
    $scope.hideSubmitButton = true;
}]);
